import * as z from 'zod';

export const CreateLocalDeliveryOptionRequest = z.object({
  localDeliveryOption: z.intersection(
    z.object({
      _id: z
        .string()
        .describe(
          'LocalDeliveryOptionId - unique identifier of local delivery option'
        )
        .regex(
          /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
          'Must be a valid GUID'
        )
        .optional()
        .nullable(),
      areaName: z
        .string()
        .describe('Area name of Local Delivery Option')
        .max(100),
      rate: z.string().describe('Flat price of local delivery'),
      estimatedDeliveryTime: z
        .string()
        .describe('Estimated delivery time description text')
        .max(40)
        .optional()
        .nullable(),
      minimumFreeDeliveryOrderAmount: z
        .number()
        .describe('Minimum order total to be eligible for free delivery')
        .optional()
        .nullable(),
      destinations: z
        .array(
          z.object({
            code: z.string().describe('Country ISO code').optional(),
            subdivisions: z.array(z.string()).max(200).optional(),
          })
        )
        .min(0)
        .max(100)
        .optional(),
      revision: z
        .string()
        .regex(/^\d+$/, 'Must be a valid UInt64 string')
        .describe(
          'Database revision of LocalDeliveryOption entity. Incremented on each modification'
        )
        .optional()
        .nullable(),
      scheduledDeliveryConfig: z
        .object({
          days: z
            .object({
              monday: z.object({
                enabledForDelivery: z
                  .boolean()
                  .describe(
                    'Shows whether this day slot is enabled for delivery'
                  ),
                timeSlots: z
                  .array(
                    z.object({
                      from: z
                        .object({
                          hours: z
                            .number()
                            .int()
                            .describe('Hours in format 0-23')
                            .min(0)
                            .max(23),
                          minutes: z
                            .number()
                            .int()
                            .describe('Minutes 0-59')
                            .min(0)
                            .max(59),
                        })
                        .describe('Starting time point of time slot'),
                      to: z
                        .object({
                          hours: z
                            .number()
                            .int()
                            .describe('Hours in format 0-23')
                            .min(0)
                            .max(23),
                          minutes: z
                            .number()
                            .int()
                            .describe('Minutes 0-59')
                            .min(0)
                            .max(59),
                        })
                        .describe('End time point of time slot'),
                    })
                  )
                  .min(0)
                  .max(8)
                  .optional(),
              }),
              tuesday: z.object({
                enabledForDelivery: z
                  .boolean()
                  .describe(
                    'Shows whether this day slot is enabled for delivery'
                  ),
                timeSlots: z
                  .array(
                    z.object({
                      from: z
                        .object({
                          hours: z
                            .number()
                            .int()
                            .describe('Hours in format 0-23')
                            .min(0)
                            .max(23),
                          minutes: z
                            .number()
                            .int()
                            .describe('Minutes 0-59')
                            .min(0)
                            .max(59),
                        })
                        .describe('Starting time point of time slot'),
                      to: z
                        .object({
                          hours: z
                            .number()
                            .int()
                            .describe('Hours in format 0-23')
                            .min(0)
                            .max(23),
                          minutes: z
                            .number()
                            .int()
                            .describe('Minutes 0-59')
                            .min(0)
                            .max(59),
                        })
                        .describe('End time point of time slot'),
                    })
                  )
                  .min(0)
                  .max(8)
                  .optional(),
              }),
              wednesday: z.object({
                enabledForDelivery: z
                  .boolean()
                  .describe(
                    'Shows whether this day slot is enabled for delivery'
                  ),
                timeSlots: z
                  .array(
                    z.object({
                      from: z
                        .object({
                          hours: z
                            .number()
                            .int()
                            .describe('Hours in format 0-23')
                            .min(0)
                            .max(23),
                          minutes: z
                            .number()
                            .int()
                            .describe('Minutes 0-59')
                            .min(0)
                            .max(59),
                        })
                        .describe('Starting time point of time slot'),
                      to: z
                        .object({
                          hours: z
                            .number()
                            .int()
                            .describe('Hours in format 0-23')
                            .min(0)
                            .max(23),
                          minutes: z
                            .number()
                            .int()
                            .describe('Minutes 0-59')
                            .min(0)
                            .max(59),
                        })
                        .describe('End time point of time slot'),
                    })
                  )
                  .min(0)
                  .max(8)
                  .optional(),
              }),
              thursday: z.object({
                enabledForDelivery: z
                  .boolean()
                  .describe(
                    'Shows whether this day slot is enabled for delivery'
                  ),
                timeSlots: z
                  .array(
                    z.object({
                      from: z
                        .object({
                          hours: z
                            .number()
                            .int()
                            .describe('Hours in format 0-23')
                            .min(0)
                            .max(23),
                          minutes: z
                            .number()
                            .int()
                            .describe('Minutes 0-59')
                            .min(0)
                            .max(59),
                        })
                        .describe('Starting time point of time slot'),
                      to: z
                        .object({
                          hours: z
                            .number()
                            .int()
                            .describe('Hours in format 0-23')
                            .min(0)
                            .max(23),
                          minutes: z
                            .number()
                            .int()
                            .describe('Minutes 0-59')
                            .min(0)
                            .max(59),
                        })
                        .describe('End time point of time slot'),
                    })
                  )
                  .min(0)
                  .max(8)
                  .optional(),
              }),
              friday: z.object({
                enabledForDelivery: z
                  .boolean()
                  .describe(
                    'Shows whether this day slot is enabled for delivery'
                  ),
                timeSlots: z
                  .array(
                    z.object({
                      from: z
                        .object({
                          hours: z
                            .number()
                            .int()
                            .describe('Hours in format 0-23')
                            .min(0)
                            .max(23),
                          minutes: z
                            .number()
                            .int()
                            .describe('Minutes 0-59')
                            .min(0)
                            .max(59),
                        })
                        .describe('Starting time point of time slot'),
                      to: z
                        .object({
                          hours: z
                            .number()
                            .int()
                            .describe('Hours in format 0-23')
                            .min(0)
                            .max(23),
                          minutes: z
                            .number()
                            .int()
                            .describe('Minutes 0-59')
                            .min(0)
                            .max(59),
                        })
                        .describe('End time point of time slot'),
                    })
                  )
                  .min(0)
                  .max(8)
                  .optional(),
              }),
              saturday: z.object({
                enabledForDelivery: z
                  .boolean()
                  .describe(
                    'Shows whether this day slot is enabled for delivery'
                  ),
                timeSlots: z
                  .array(
                    z.object({
                      from: z
                        .object({
                          hours: z
                            .number()
                            .int()
                            .describe('Hours in format 0-23')
                            .min(0)
                            .max(23),
                          minutes: z
                            .number()
                            .int()
                            .describe('Minutes 0-59')
                            .min(0)
                            .max(59),
                        })
                        .describe('Starting time point of time slot'),
                      to: z
                        .object({
                          hours: z
                            .number()
                            .int()
                            .describe('Hours in format 0-23')
                            .min(0)
                            .max(23),
                          minutes: z
                            .number()
                            .int()
                            .describe('Minutes 0-59')
                            .min(0)
                            .max(59),
                        })
                        .describe('End time point of time slot'),
                    })
                  )
                  .min(0)
                  .max(8)
                  .optional(),
              }),
              sunday: z.object({
                enabledForDelivery: z
                  .boolean()
                  .describe(
                    'Shows whether this day slot is enabled for delivery'
                  ),
                timeSlots: z
                  .array(
                    z.object({
                      from: z
                        .object({
                          hours: z
                            .number()
                            .int()
                            .describe('Hours in format 0-23')
                            .min(0)
                            .max(23),
                          minutes: z
                            .number()
                            .int()
                            .describe('Minutes 0-59')
                            .min(0)
                            .max(59),
                        })
                        .describe('Starting time point of time slot'),
                      to: z
                        .object({
                          hours: z
                            .number()
                            .int()
                            .describe('Hours in format 0-23')
                            .min(0)
                            .max(23),
                          minutes: z
                            .number()
                            .int()
                            .describe('Minutes 0-59')
                            .min(0)
                            .max(59),
                        })
                        .describe('End time point of time slot'),
                    })
                  )
                  .min(0)
                  .max(8)
                  .optional(),
              }),
            })
            .describe(
              "Days config which contain days when delivery is enabled with it's time slots"
            )
            .optional(),
          handlingDays: z
            .number()
            .int()
            .describe('Amount of days before first delivery option date')
            .min(0)
            .max(30),
          cutOffTime: z
            .object({
              hours: z
                .number()
                .int()
                .describe('Hours in format 0-23')
                .min(0)
                .max(23),
              minutes: z.number().int().describe('Minutes 0-59').min(0).max(59),
            })
            .describe(
              'Cut off time after which first delivery option would be for next day'
            )
            .optional(),
          timeWindows: z
            .array(
              z.object({
                day: z
                  .enum(['MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT', 'SUN'])
                  .optional(),
                start: z
                  .object({
                    hours: z
                      .number()
                      .int()
                      .describe('Hours')
                      .min(0)
                      .max(23)
                      .optional(),
                    minutes: z
                      .number()
                      .int()
                      .describe('Minutes')
                      .min(0)
                      .max(59)
                      .optional(),
                  })
                  .describe('The start time in time of day representation.')
                  .optional(),
                end: z
                  .object({
                    hours: z
                      .number()
                      .int()
                      .describe('Hours')
                      .min(0)
                      .max(23)
                      .optional(),
                    minutes: z
                      .number()
                      .int()
                      .describe('Minutes')
                      .min(0)
                      .max(59)
                      .optional(),
                  })
                  .describe('The end time in time of day representation.')
                  .optional(),
                enabled: z
                  .boolean()
                  .describe('Whether this timeWindow availability is enabled.')
                  .optional()
                  .nullable(),
              })
            )
            .min(0)
            .max(100)
            .optional(),
        })
        .optional(),
      rates: z
        .array(
          z.object({
            amount: z
              .string()
              .describe(
                'there is an AND logic between all the conditions. Empty conditions means true.\nThe amount of the rate that will be returned if all conditions are met.'
              )
              .optional(),
            conditions: z
              .array(
                z.object({
                  type: z
                    .enum([
                      'BY_TOTAL_WEIGHT',
                      'BY_TOTAL_PRICE',
                      'BY_TOTAL_QUANTITY',
                    ])
                    .optional(),
                  value: z
                    .string()
                    .describe(
                      'The value in respective to the condition type\nWeight values should be in the same weight units of the store: KG / LB\nTotal price is according to the store currency\nQuantity of items should be integers'
                    )
                    .optional(),
                  operator: z.enum(['EQ', 'GT', 'GTE', 'LT', 'LTE']).optional(),
                })
              )
              .min(0)
              .max(10)
              .optional(),
            multiplyByQuantity: z
              .boolean()
              .describe(
                'When this flag is set to true, multiply the amount by the number of line items passed on the request.'
              )
              .optional(),
          })
        )
        .max(50)
        .optional(),
      _createdDate: z
        .date()
        .describe('Date and time the LocalDeliveryOption was created.')
        .optional()
        .nullable(),
      _updatedDate: z
        .date()
        .describe('Date and time the LocalDeliveryOption was last updated.')
        .optional()
        .nullable(),
      deliveryRegionIds: z.array(z.string()).max(50).optional(),
    }),
    z.xor([
      z.object({
        zipConfig: z.never().optional(),
        radiusConfig: z.never().optional(),
        customAreaConfig: z.never().optional(),
        cityConfig: z.never().optional(),
      }),
      z.object({
        radiusConfig: z.never().optional(),
        customAreaConfig: z.never().optional(),
        cityConfig: z.never().optional(),
        zipConfig: z.object({ zipCodes: z.array(z.string()).optional() }),
      }),
      z.object({
        zipConfig: z.never().optional(),
        customAreaConfig: z.never().optional(),
        cityConfig: z.never().optional(),
        radiusConfig: z.object({
          radius: z
            .number()
            .describe("Delivery circle's radius")
            .min(0.1)
            .max(50)
            .optional(),
          lengthUnit: z
            .enum(['UNSPECIFIED_LENGTH_UNIT', 'KM', 'MI'])
            .describe("Radius' unit, taken from site properties")
            .optional(),
        }),
      }),
      z.object({
        zipConfig: z.never().optional(),
        radiusConfig: z.never().optional(),
        cityConfig: z.never().optional(),
        customAreaConfig: z.object({
          geocodes: z
            .array(
              z.object({
                latitude: z
                  .number()
                  .describe('Address latitude.')
                  .optional()
                  .nullable(),
                longitude: z
                  .number()
                  .describe('Address longitude.')
                  .optional()
                  .nullable(),
              })
            )
            .max(300)
            .optional(),
        }),
      }),
      z.object({
        zipConfig: z.never().optional(),
        radiusConfig: z.never().optional(),
        customAreaConfig: z.never().optional(),
        cityConfig: z.object({
          cityItems: z
            .array(
              z.object({
                cityName: z
                  .string()
                  .describe('Name of the city')
                  .min(1)
                  .max(100)
                  .optional(),
                subdivision: z
                  .string()
                  .describe('Subdivision code of the city')
                  .optional()
                  .nullable(),
                country: z
                  .string()
                  .describe('Country code of the city')
                  .optional(),
                cityKey: z
                  .string()
                  .describe('Unique code of the city, calculated by Wix')
                  .max(100)
                  .optional()
                  .nullable(),
              })
            )
            .min(1)
            .max(50)
            .optional(),
        }),
      }),
    ])
  ),
});
export const CreateLocalDeliveryOptionResponse = z.intersection(
  z.object({
    _id: z
      .string()
      .describe(
        'LocalDeliveryOptionId - unique identifier of local delivery option'
      )
      .regex(
        /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
        'Must be a valid GUID'
      )
      .optional()
      .nullable(),
    areaName: z
      .string()
      .describe('Area name of Local Delivery Option')
      .max(100)
      .optional()
      .nullable(),
    rate: z
      .string()
      .describe('Flat price of local delivery')
      .optional()
      .nullable(),
    estimatedDeliveryTime: z
      .string()
      .describe('Estimated delivery time description text')
      .max(40)
      .optional()
      .nullable(),
    minimumFreeDeliveryOrderAmount: z
      .number()
      .describe('Minimum order total to be eligible for free delivery')
      .optional()
      .nullable(),
    destinations: z
      .array(
        z.object({
          code: z.string().describe('Country ISO code').optional(),
          subdivisions: z.array(z.string()).max(200).optional(),
        })
      )
      .min(0)
      .max(100)
      .optional(),
    revision: z
      .string()
      .regex(/^\d+$/, 'Must be a valid UInt64 string')
      .describe(
        'Database revision of LocalDeliveryOption entity. Incremented on each modification'
      )
      .optional()
      .nullable(),
    scheduledDeliveryConfig: z
      .object({
        days: z
          .object({
            monday: z
              .object({
                enabledForDelivery: z
                  .boolean()
                  .describe(
                    'Shows whether this day slot is enabled for delivery'
                  )
                  .optional()
                  .nullable(),
                timeSlots: z
                  .array(
                    z.object({
                      from: z
                        .object({
                          hours: z
                            .number()
                            .int()
                            .describe('Hours in format 0-23')
                            .min(0)
                            .max(23)
                            .optional()
                            .nullable(),
                          minutes: z
                            .number()
                            .int()
                            .describe('Minutes 0-59')
                            .min(0)
                            .max(59)
                            .optional()
                            .nullable(),
                        })
                        .describe('Starting time point of time slot')
                        .optional(),
                      to: z
                        .object({
                          hours: z
                            .number()
                            .int()
                            .describe('Hours in format 0-23')
                            .min(0)
                            .max(23)
                            .optional()
                            .nullable(),
                          minutes: z
                            .number()
                            .int()
                            .describe('Minutes 0-59')
                            .min(0)
                            .max(59)
                            .optional()
                            .nullable(),
                        })
                        .describe('End time point of time slot')
                        .optional(),
                    })
                  )
                  .min(0)
                  .max(8)
                  .optional(),
              })
              .optional(),
            tuesday: z
              .object({
                enabledForDelivery: z
                  .boolean()
                  .describe(
                    'Shows whether this day slot is enabled for delivery'
                  )
                  .optional()
                  .nullable(),
                timeSlots: z
                  .array(
                    z.object({
                      from: z
                        .object({
                          hours: z
                            .number()
                            .int()
                            .describe('Hours in format 0-23')
                            .min(0)
                            .max(23)
                            .optional()
                            .nullable(),
                          minutes: z
                            .number()
                            .int()
                            .describe('Minutes 0-59')
                            .min(0)
                            .max(59)
                            .optional()
                            .nullable(),
                        })
                        .describe('Starting time point of time slot')
                        .optional(),
                      to: z
                        .object({
                          hours: z
                            .number()
                            .int()
                            .describe('Hours in format 0-23')
                            .min(0)
                            .max(23)
                            .optional()
                            .nullable(),
                          minutes: z
                            .number()
                            .int()
                            .describe('Minutes 0-59')
                            .min(0)
                            .max(59)
                            .optional()
                            .nullable(),
                        })
                        .describe('End time point of time slot')
                        .optional(),
                    })
                  )
                  .min(0)
                  .max(8)
                  .optional(),
              })
              .optional(),
            wednesday: z
              .object({
                enabledForDelivery: z
                  .boolean()
                  .describe(
                    'Shows whether this day slot is enabled for delivery'
                  )
                  .optional()
                  .nullable(),
                timeSlots: z
                  .array(
                    z.object({
                      from: z
                        .object({
                          hours: z
                            .number()
                            .int()
                            .describe('Hours in format 0-23')
                            .min(0)
                            .max(23)
                            .optional()
                            .nullable(),
                          minutes: z
                            .number()
                            .int()
                            .describe('Minutes 0-59')
                            .min(0)
                            .max(59)
                            .optional()
                            .nullable(),
                        })
                        .describe('Starting time point of time slot')
                        .optional(),
                      to: z
                        .object({
                          hours: z
                            .number()
                            .int()
                            .describe('Hours in format 0-23')
                            .min(0)
                            .max(23)
                            .optional()
                            .nullable(),
                          minutes: z
                            .number()
                            .int()
                            .describe('Minutes 0-59')
                            .min(0)
                            .max(59)
                            .optional()
                            .nullable(),
                        })
                        .describe('End time point of time slot')
                        .optional(),
                    })
                  )
                  .min(0)
                  .max(8)
                  .optional(),
              })
              .optional(),
            thursday: z
              .object({
                enabledForDelivery: z
                  .boolean()
                  .describe(
                    'Shows whether this day slot is enabled for delivery'
                  )
                  .optional()
                  .nullable(),
                timeSlots: z
                  .array(
                    z.object({
                      from: z
                        .object({
                          hours: z
                            .number()
                            .int()
                            .describe('Hours in format 0-23')
                            .min(0)
                            .max(23)
                            .optional()
                            .nullable(),
                          minutes: z
                            .number()
                            .int()
                            .describe('Minutes 0-59')
                            .min(0)
                            .max(59)
                            .optional()
                            .nullable(),
                        })
                        .describe('Starting time point of time slot')
                        .optional(),
                      to: z
                        .object({
                          hours: z
                            .number()
                            .int()
                            .describe('Hours in format 0-23')
                            .min(0)
                            .max(23)
                            .optional()
                            .nullable(),
                          minutes: z
                            .number()
                            .int()
                            .describe('Minutes 0-59')
                            .min(0)
                            .max(59)
                            .optional()
                            .nullable(),
                        })
                        .describe('End time point of time slot')
                        .optional(),
                    })
                  )
                  .min(0)
                  .max(8)
                  .optional(),
              })
              .optional(),
            friday: z
              .object({
                enabledForDelivery: z
                  .boolean()
                  .describe(
                    'Shows whether this day slot is enabled for delivery'
                  )
                  .optional()
                  .nullable(),
                timeSlots: z
                  .array(
                    z.object({
                      from: z
                        .object({
                          hours: z
                            .number()
                            .int()
                            .describe('Hours in format 0-23')
                            .min(0)
                            .max(23)
                            .optional()
                            .nullable(),
                          minutes: z
                            .number()
                            .int()
                            .describe('Minutes 0-59')
                            .min(0)
                            .max(59)
                            .optional()
                            .nullable(),
                        })
                        .describe('Starting time point of time slot')
                        .optional(),
                      to: z
                        .object({
                          hours: z
                            .number()
                            .int()
                            .describe('Hours in format 0-23')
                            .min(0)
                            .max(23)
                            .optional()
                            .nullable(),
                          minutes: z
                            .number()
                            .int()
                            .describe('Minutes 0-59')
                            .min(0)
                            .max(59)
                            .optional()
                            .nullable(),
                        })
                        .describe('End time point of time slot')
                        .optional(),
                    })
                  )
                  .min(0)
                  .max(8)
                  .optional(),
              })
              .optional(),
            saturday: z
              .object({
                enabledForDelivery: z
                  .boolean()
                  .describe(
                    'Shows whether this day slot is enabled for delivery'
                  )
                  .optional()
                  .nullable(),
                timeSlots: z
                  .array(
                    z.object({
                      from: z
                        .object({
                          hours: z
                            .number()
                            .int()
                            .describe('Hours in format 0-23')
                            .min(0)
                            .max(23)
                            .optional()
                            .nullable(),
                          minutes: z
                            .number()
                            .int()
                            .describe('Minutes 0-59')
                            .min(0)
                            .max(59)
                            .optional()
                            .nullable(),
                        })
                        .describe('Starting time point of time slot')
                        .optional(),
                      to: z
                        .object({
                          hours: z
                            .number()
                            .int()
                            .describe('Hours in format 0-23')
                            .min(0)
                            .max(23)
                            .optional()
                            .nullable(),
                          minutes: z
                            .number()
                            .int()
                            .describe('Minutes 0-59')
                            .min(0)
                            .max(59)
                            .optional()
                            .nullable(),
                        })
                        .describe('End time point of time slot')
                        .optional(),
                    })
                  )
                  .min(0)
                  .max(8)
                  .optional(),
              })
              .optional(),
            sunday: z
              .object({
                enabledForDelivery: z
                  .boolean()
                  .describe(
                    'Shows whether this day slot is enabled for delivery'
                  )
                  .optional()
                  .nullable(),
                timeSlots: z
                  .array(
                    z.object({
                      from: z
                        .object({
                          hours: z
                            .number()
                            .int()
                            .describe('Hours in format 0-23')
                            .min(0)
                            .max(23)
                            .optional()
                            .nullable(),
                          minutes: z
                            .number()
                            .int()
                            .describe('Minutes 0-59')
                            .min(0)
                            .max(59)
                            .optional()
                            .nullable(),
                        })
                        .describe('Starting time point of time slot')
                        .optional(),
                      to: z
                        .object({
                          hours: z
                            .number()
                            .int()
                            .describe('Hours in format 0-23')
                            .min(0)
                            .max(23)
                            .optional()
                            .nullable(),
                          minutes: z
                            .number()
                            .int()
                            .describe('Minutes 0-59')
                            .min(0)
                            .max(59)
                            .optional()
                            .nullable(),
                        })
                        .describe('End time point of time slot')
                        .optional(),
                    })
                  )
                  .min(0)
                  .max(8)
                  .optional(),
              })
              .optional(),
          })
          .describe(
            "Days config which contain days when delivery is enabled with it's time slots"
          )
          .optional(),
        handlingDays: z
          .number()
          .int()
          .describe('Amount of days before first delivery option date')
          .min(0)
          .max(30)
          .optional()
          .nullable(),
        cutOffTime: z
          .object({
            hours: z
              .number()
              .int()
              .describe('Hours in format 0-23')
              .min(0)
              .max(23)
              .optional()
              .nullable(),
            minutes: z
              .number()
              .int()
              .describe('Minutes 0-59')
              .min(0)
              .max(59)
              .optional()
              .nullable(),
          })
          .describe(
            'Cut off time after which first delivery option would be for next day'
          )
          .optional(),
        timeWindows: z
          .array(
            z.object({
              day: z
                .enum(['MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT', 'SUN'])
                .describe('The day of week this availability relates to.')
                .optional(),
              start: z
                .object({
                  hours: z
                    .number()
                    .int()
                    .describe('Hours')
                    .min(0)
                    .max(23)
                    .optional(),
                  minutes: z
                    .number()
                    .int()
                    .describe('Minutes')
                    .min(0)
                    .max(59)
                    .optional(),
                })
                .describe('The start time in time of day representation.')
                .optional(),
              end: z
                .object({
                  hours: z
                    .number()
                    .int()
                    .describe('Hours')
                    .min(0)
                    .max(23)
                    .optional(),
                  minutes: z
                    .number()
                    .int()
                    .describe('Minutes')
                    .min(0)
                    .max(59)
                    .optional(),
                })
                .describe('The end time in time of day representation.')
                .optional(),
              enabled: z
                .boolean()
                .describe('Whether this timeWindow availability is enabled.')
                .optional()
                .nullable(),
            })
          )
          .min(0)
          .max(100)
          .optional(),
      })
      .optional(),
    rates: z
      .array(
        z.object({
          amount: z
            .string()
            .describe(
              'there is an AND logic between all the conditions. Empty conditions means true.\nThe amount of the rate that will be returned if all conditions are met.'
            )
            .optional(),
          conditions: z
            .array(
              z.object({
                type: z
                  .enum([
                    'BY_TOTAL_WEIGHT',
                    'BY_TOTAL_PRICE',
                    'BY_TOTAL_QUANTITY',
                  ])
                  .optional(),
                value: z
                  .string()
                  .describe(
                    'The value in respective to the condition type\nWeight values should be in the same weight units of the store: KG / LB\nTotal price is according to the store currency\nQuantity of items should be integers'
                  )
                  .optional(),
                operator: z
                  .enum(['EQ', 'GT', 'GTE', 'LT', 'LTE'])
                  .describe('Logical operator.')
                  .optional(),
              })
            )
            .min(0)
            .max(10)
            .optional(),
          multiplyByQuantity: z
            .boolean()
            .describe(
              'When this flag is set to true, multiply the amount by the number of line items passed on the request.'
            )
            .optional(),
        })
      )
      .max(50)
      .optional(),
    _createdDate: z
      .date()
      .describe('Date and time the LocalDeliveryOption was created.')
      .optional()
      .nullable(),
    _updatedDate: z
      .date()
      .describe('Date and time the LocalDeliveryOption was last updated.')
      .optional()
      .nullable(),
    deliveryRegionIds: z.array(z.string()).max(50).optional(),
  }),
  z.xor([
    z.object({
      zipConfig: z.never().optional(),
      radiusConfig: z.never().optional(),
      customAreaConfig: z.never().optional(),
      cityConfig: z.never().optional(),
    }),
    z.object({
      radiusConfig: z.never().optional(),
      customAreaConfig: z.never().optional(),
      cityConfig: z.never().optional(),
      zipConfig: z.object({ zipCodes: z.array(z.string()).optional() }),
    }),
    z.object({
      zipConfig: z.never().optional(),
      customAreaConfig: z.never().optional(),
      cityConfig: z.never().optional(),
      radiusConfig: z.object({
        radius: z
          .number()
          .describe("Delivery circle's radius")
          .min(0.1)
          .max(50)
          .optional(),
        lengthUnit: z
          .enum(['UNSPECIFIED_LENGTH_UNIT', 'KM', 'MI'])
          .describe("Radius' unit, taken from site properties")
          .optional(),
      }),
    }),
    z.object({
      zipConfig: z.never().optional(),
      radiusConfig: z.never().optional(),
      cityConfig: z.never().optional(),
      customAreaConfig: z.object({
        geocodes: z
          .array(
            z.object({
              latitude: z
                .number()
                .describe('Address latitude.')
                .optional()
                .nullable(),
              longitude: z
                .number()
                .describe('Address longitude.')
                .optional()
                .nullable(),
            })
          )
          .max(300)
          .optional(),
      }),
    }),
    z.object({
      zipConfig: z.never().optional(),
      radiusConfig: z.never().optional(),
      customAreaConfig: z.never().optional(),
      cityConfig: z.object({
        cityItems: z
          .array(
            z.object({
              cityName: z
                .string()
                .describe('Name of the city')
                .min(1)
                .max(100)
                .optional(),
              subdivision: z
                .string()
                .describe('Subdivision code of the city')
                .optional()
                .nullable(),
              country: z
                .string()
                .describe('Country code of the city')
                .optional(),
              cityKey: z
                .string()
                .describe('Unique code of the city, calculated by Wix')
                .max(100)
                .optional()
                .nullable(),
            })
          )
          .min(1)
          .max(50)
          .optional(),
      }),
    }),
  ])
);
export const GetLocalDeliveryOptionRequest = z.object({
  localDeliveryOptionId: z.string().max(50),
  options: z.object({ id: z.string().max(50).optional() }).optional(),
});
export const GetLocalDeliveryOptionResponse = z.intersection(
  z.object({
    _id: z
      .string()
      .describe(
        'LocalDeliveryOptionId - unique identifier of local delivery option'
      )
      .regex(
        /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
        'Must be a valid GUID'
      )
      .optional()
      .nullable(),
    areaName: z
      .string()
      .describe('Area name of Local Delivery Option')
      .max(100)
      .optional()
      .nullable(),
    rate: z
      .string()
      .describe('Flat price of local delivery')
      .optional()
      .nullable(),
    estimatedDeliveryTime: z
      .string()
      .describe('Estimated delivery time description text')
      .max(40)
      .optional()
      .nullable(),
    minimumFreeDeliveryOrderAmount: z
      .number()
      .describe('Minimum order total to be eligible for free delivery')
      .optional()
      .nullable(),
    destinations: z
      .array(
        z.object({
          code: z.string().describe('Country ISO code').optional(),
          subdivisions: z.array(z.string()).max(200).optional(),
        })
      )
      .min(0)
      .max(100)
      .optional(),
    revision: z
      .string()
      .regex(/^\d+$/, 'Must be a valid UInt64 string')
      .describe(
        'Database revision of LocalDeliveryOption entity. Incremented on each modification'
      )
      .optional()
      .nullable(),
    scheduledDeliveryConfig: z
      .object({
        days: z
          .object({
            monday: z
              .object({
                enabledForDelivery: z
                  .boolean()
                  .describe(
                    'Shows whether this day slot is enabled for delivery'
                  )
                  .optional()
                  .nullable(),
                timeSlots: z
                  .array(
                    z.object({
                      from: z
                        .object({
                          hours: z
                            .number()
                            .int()
                            .describe('Hours in format 0-23')
                            .min(0)
                            .max(23)
                            .optional()
                            .nullable(),
                          minutes: z
                            .number()
                            .int()
                            .describe('Minutes 0-59')
                            .min(0)
                            .max(59)
                            .optional()
                            .nullable(),
                        })
                        .describe('Starting time point of time slot')
                        .optional(),
                      to: z
                        .object({
                          hours: z
                            .number()
                            .int()
                            .describe('Hours in format 0-23')
                            .min(0)
                            .max(23)
                            .optional()
                            .nullable(),
                          minutes: z
                            .number()
                            .int()
                            .describe('Minutes 0-59')
                            .min(0)
                            .max(59)
                            .optional()
                            .nullable(),
                        })
                        .describe('End time point of time slot')
                        .optional(),
                    })
                  )
                  .min(0)
                  .max(8)
                  .optional(),
              })
              .optional(),
            tuesday: z
              .object({
                enabledForDelivery: z
                  .boolean()
                  .describe(
                    'Shows whether this day slot is enabled for delivery'
                  )
                  .optional()
                  .nullable(),
                timeSlots: z
                  .array(
                    z.object({
                      from: z
                        .object({
                          hours: z
                            .number()
                            .int()
                            .describe('Hours in format 0-23')
                            .min(0)
                            .max(23)
                            .optional()
                            .nullable(),
                          minutes: z
                            .number()
                            .int()
                            .describe('Minutes 0-59')
                            .min(0)
                            .max(59)
                            .optional()
                            .nullable(),
                        })
                        .describe('Starting time point of time slot')
                        .optional(),
                      to: z
                        .object({
                          hours: z
                            .number()
                            .int()
                            .describe('Hours in format 0-23')
                            .min(0)
                            .max(23)
                            .optional()
                            .nullable(),
                          minutes: z
                            .number()
                            .int()
                            .describe('Minutes 0-59')
                            .min(0)
                            .max(59)
                            .optional()
                            .nullable(),
                        })
                        .describe('End time point of time slot')
                        .optional(),
                    })
                  )
                  .min(0)
                  .max(8)
                  .optional(),
              })
              .optional(),
            wednesday: z
              .object({
                enabledForDelivery: z
                  .boolean()
                  .describe(
                    'Shows whether this day slot is enabled for delivery'
                  )
                  .optional()
                  .nullable(),
                timeSlots: z
                  .array(
                    z.object({
                      from: z
                        .object({
                          hours: z
                            .number()
                            .int()
                            .describe('Hours in format 0-23')
                            .min(0)
                            .max(23)
                            .optional()
                            .nullable(),
                          minutes: z
                            .number()
                            .int()
                            .describe('Minutes 0-59')
                            .min(0)
                            .max(59)
                            .optional()
                            .nullable(),
                        })
                        .describe('Starting time point of time slot')
                        .optional(),
                      to: z
                        .object({
                          hours: z
                            .number()
                            .int()
                            .describe('Hours in format 0-23')
                            .min(0)
                            .max(23)
                            .optional()
                            .nullable(),
                          minutes: z
                            .number()
                            .int()
                            .describe('Minutes 0-59')
                            .min(0)
                            .max(59)
                            .optional()
                            .nullable(),
                        })
                        .describe('End time point of time slot')
                        .optional(),
                    })
                  )
                  .min(0)
                  .max(8)
                  .optional(),
              })
              .optional(),
            thursday: z
              .object({
                enabledForDelivery: z
                  .boolean()
                  .describe(
                    'Shows whether this day slot is enabled for delivery'
                  )
                  .optional()
                  .nullable(),
                timeSlots: z
                  .array(
                    z.object({
                      from: z
                        .object({
                          hours: z
                            .number()
                            .int()
                            .describe('Hours in format 0-23')
                            .min(0)
                            .max(23)
                            .optional()
                            .nullable(),
                          minutes: z
                            .number()
                            .int()
                            .describe('Minutes 0-59')
                            .min(0)
                            .max(59)
                            .optional()
                            .nullable(),
                        })
                        .describe('Starting time point of time slot')
                        .optional(),
                      to: z
                        .object({
                          hours: z
                            .number()
                            .int()
                            .describe('Hours in format 0-23')
                            .min(0)
                            .max(23)
                            .optional()
                            .nullable(),
                          minutes: z
                            .number()
                            .int()
                            .describe('Minutes 0-59')
                            .min(0)
                            .max(59)
                            .optional()
                            .nullable(),
                        })
                        .describe('End time point of time slot')
                        .optional(),
                    })
                  )
                  .min(0)
                  .max(8)
                  .optional(),
              })
              .optional(),
            friday: z
              .object({
                enabledForDelivery: z
                  .boolean()
                  .describe(
                    'Shows whether this day slot is enabled for delivery'
                  )
                  .optional()
                  .nullable(),
                timeSlots: z
                  .array(
                    z.object({
                      from: z
                        .object({
                          hours: z
                            .number()
                            .int()
                            .describe('Hours in format 0-23')
                            .min(0)
                            .max(23)
                            .optional()
                            .nullable(),
                          minutes: z
                            .number()
                            .int()
                            .describe('Minutes 0-59')
                            .min(0)
                            .max(59)
                            .optional()
                            .nullable(),
                        })
                        .describe('Starting time point of time slot')
                        .optional(),
                      to: z
                        .object({
                          hours: z
                            .number()
                            .int()
                            .describe('Hours in format 0-23')
                            .min(0)
                            .max(23)
                            .optional()
                            .nullable(),
                          minutes: z
                            .number()
                            .int()
                            .describe('Minutes 0-59')
                            .min(0)
                            .max(59)
                            .optional()
                            .nullable(),
                        })
                        .describe('End time point of time slot')
                        .optional(),
                    })
                  )
                  .min(0)
                  .max(8)
                  .optional(),
              })
              .optional(),
            saturday: z
              .object({
                enabledForDelivery: z
                  .boolean()
                  .describe(
                    'Shows whether this day slot is enabled for delivery'
                  )
                  .optional()
                  .nullable(),
                timeSlots: z
                  .array(
                    z.object({
                      from: z
                        .object({
                          hours: z
                            .number()
                            .int()
                            .describe('Hours in format 0-23')
                            .min(0)
                            .max(23)
                            .optional()
                            .nullable(),
                          minutes: z
                            .number()
                            .int()
                            .describe('Minutes 0-59')
                            .min(0)
                            .max(59)
                            .optional()
                            .nullable(),
                        })
                        .describe('Starting time point of time slot')
                        .optional(),
                      to: z
                        .object({
                          hours: z
                            .number()
                            .int()
                            .describe('Hours in format 0-23')
                            .min(0)
                            .max(23)
                            .optional()
                            .nullable(),
                          minutes: z
                            .number()
                            .int()
                            .describe('Minutes 0-59')
                            .min(0)
                            .max(59)
                            .optional()
                            .nullable(),
                        })
                        .describe('End time point of time slot')
                        .optional(),
                    })
                  )
                  .min(0)
                  .max(8)
                  .optional(),
              })
              .optional(),
            sunday: z
              .object({
                enabledForDelivery: z
                  .boolean()
                  .describe(
                    'Shows whether this day slot is enabled for delivery'
                  )
                  .optional()
                  .nullable(),
                timeSlots: z
                  .array(
                    z.object({
                      from: z
                        .object({
                          hours: z
                            .number()
                            .int()
                            .describe('Hours in format 0-23')
                            .min(0)
                            .max(23)
                            .optional()
                            .nullable(),
                          minutes: z
                            .number()
                            .int()
                            .describe('Minutes 0-59')
                            .min(0)
                            .max(59)
                            .optional()
                            .nullable(),
                        })
                        .describe('Starting time point of time slot')
                        .optional(),
                      to: z
                        .object({
                          hours: z
                            .number()
                            .int()
                            .describe('Hours in format 0-23')
                            .min(0)
                            .max(23)
                            .optional()
                            .nullable(),
                          minutes: z
                            .number()
                            .int()
                            .describe('Minutes 0-59')
                            .min(0)
                            .max(59)
                            .optional()
                            .nullable(),
                        })
                        .describe('End time point of time slot')
                        .optional(),
                    })
                  )
                  .min(0)
                  .max(8)
                  .optional(),
              })
              .optional(),
          })
          .describe(
            "Days config which contain days when delivery is enabled with it's time slots"
          )
          .optional(),
        handlingDays: z
          .number()
          .int()
          .describe('Amount of days before first delivery option date')
          .min(0)
          .max(30)
          .optional()
          .nullable(),
        cutOffTime: z
          .object({
            hours: z
              .number()
              .int()
              .describe('Hours in format 0-23')
              .min(0)
              .max(23)
              .optional()
              .nullable(),
            minutes: z
              .number()
              .int()
              .describe('Minutes 0-59')
              .min(0)
              .max(59)
              .optional()
              .nullable(),
          })
          .describe(
            'Cut off time after which first delivery option would be for next day'
          )
          .optional(),
        timeWindows: z
          .array(
            z.object({
              day: z
                .enum(['MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT', 'SUN'])
                .describe('The day of week this availability relates to.')
                .optional(),
              start: z
                .object({
                  hours: z
                    .number()
                    .int()
                    .describe('Hours')
                    .min(0)
                    .max(23)
                    .optional(),
                  minutes: z
                    .number()
                    .int()
                    .describe('Minutes')
                    .min(0)
                    .max(59)
                    .optional(),
                })
                .describe('The start time in time of day representation.')
                .optional(),
              end: z
                .object({
                  hours: z
                    .number()
                    .int()
                    .describe('Hours')
                    .min(0)
                    .max(23)
                    .optional(),
                  minutes: z
                    .number()
                    .int()
                    .describe('Minutes')
                    .min(0)
                    .max(59)
                    .optional(),
                })
                .describe('The end time in time of day representation.')
                .optional(),
              enabled: z
                .boolean()
                .describe('Whether this timeWindow availability is enabled.')
                .optional()
                .nullable(),
            })
          )
          .min(0)
          .max(100)
          .optional(),
      })
      .optional(),
    rates: z
      .array(
        z.object({
          amount: z
            .string()
            .describe(
              'there is an AND logic between all the conditions. Empty conditions means true.\nThe amount of the rate that will be returned if all conditions are met.'
            )
            .optional(),
          conditions: z
            .array(
              z.object({
                type: z
                  .enum([
                    'BY_TOTAL_WEIGHT',
                    'BY_TOTAL_PRICE',
                    'BY_TOTAL_QUANTITY',
                  ])
                  .optional(),
                value: z
                  .string()
                  .describe(
                    'The value in respective to the condition type\nWeight values should be in the same weight units of the store: KG / LB\nTotal price is according to the store currency\nQuantity of items should be integers'
                  )
                  .optional(),
                operator: z
                  .enum(['EQ', 'GT', 'GTE', 'LT', 'LTE'])
                  .describe('Logical operator.')
                  .optional(),
              })
            )
            .min(0)
            .max(10)
            .optional(),
          multiplyByQuantity: z
            .boolean()
            .describe(
              'When this flag is set to true, multiply the amount by the number of line items passed on the request.'
            )
            .optional(),
        })
      )
      .max(50)
      .optional(),
    _createdDate: z
      .date()
      .describe('Date and time the LocalDeliveryOption was created.')
      .optional()
      .nullable(),
    _updatedDate: z
      .date()
      .describe('Date and time the LocalDeliveryOption was last updated.')
      .optional()
      .nullable(),
    deliveryRegionIds: z.array(z.string()).max(50).optional(),
  }),
  z.xor([
    z.object({
      zipConfig: z.never().optional(),
      radiusConfig: z.never().optional(),
      customAreaConfig: z.never().optional(),
      cityConfig: z.never().optional(),
    }),
    z.object({
      radiusConfig: z.never().optional(),
      customAreaConfig: z.never().optional(),
      cityConfig: z.never().optional(),
      zipConfig: z.object({ zipCodes: z.array(z.string()).optional() }),
    }),
    z.object({
      zipConfig: z.never().optional(),
      customAreaConfig: z.never().optional(),
      cityConfig: z.never().optional(),
      radiusConfig: z.object({
        radius: z
          .number()
          .describe("Delivery circle's radius")
          .min(0.1)
          .max(50)
          .optional(),
        lengthUnit: z
          .enum(['UNSPECIFIED_LENGTH_UNIT', 'KM', 'MI'])
          .describe("Radius' unit, taken from site properties")
          .optional(),
      }),
    }),
    z.object({
      zipConfig: z.never().optional(),
      radiusConfig: z.never().optional(),
      cityConfig: z.never().optional(),
      customAreaConfig: z.object({
        geocodes: z
          .array(
            z.object({
              latitude: z
                .number()
                .describe('Address latitude.')
                .optional()
                .nullable(),
              longitude: z
                .number()
                .describe('Address longitude.')
                .optional()
                .nullable(),
            })
          )
          .max(300)
          .optional(),
      }),
    }),
    z.object({
      zipConfig: z.never().optional(),
      radiusConfig: z.never().optional(),
      customAreaConfig: z.never().optional(),
      cityConfig: z.object({
        cityItems: z
          .array(
            z.object({
              cityName: z
                .string()
                .describe('Name of the city')
                .min(1)
                .max(100)
                .optional(),
              subdivision: z
                .string()
                .describe('Subdivision code of the city')
                .optional()
                .nullable(),
              country: z
                .string()
                .describe('Country code of the city')
                .optional(),
              cityKey: z
                .string()
                .describe('Unique code of the city, calculated by Wix')
                .max(100)
                .optional()
                .nullable(),
            })
          )
          .min(1)
          .max(50)
          .optional(),
      }),
    }),
  ])
);
export const ListLocalDeliveryOptionsRequest = z.object({
  externalId: z
    .string()
    .regex(
      /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
      'Must be a valid GUID'
    ),
});
export const ListLocalDeliveryOptionsResponse = z.object({
  localDeliveryOptions: z
    .array(
      z.intersection(
        z.object({
          _id: z
            .string()
            .describe(
              'LocalDeliveryOptionId - unique identifier of local delivery option'
            )
            .regex(
              /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
              'Must be a valid GUID'
            )
            .optional()
            .nullable(),
          areaName: z
            .string()
            .describe('Area name of Local Delivery Option')
            .max(100)
            .optional()
            .nullable(),
          rate: z
            .string()
            .describe('Flat price of local delivery')
            .optional()
            .nullable(),
          estimatedDeliveryTime: z
            .string()
            .describe('Estimated delivery time description text')
            .max(40)
            .optional()
            .nullable(),
          minimumFreeDeliveryOrderAmount: z
            .number()
            .describe('Minimum order total to be eligible for free delivery')
            .optional()
            .nullable(),
          destinations: z
            .array(
              z.object({
                code: z.string().describe('Country ISO code').optional(),
                subdivisions: z.array(z.string()).max(200).optional(),
              })
            )
            .min(0)
            .max(100)
            .optional(),
          revision: z
            .string()
            .regex(/^\d+$/, 'Must be a valid UInt64 string')
            .describe(
              'Database revision of LocalDeliveryOption entity. Incremented on each modification'
            )
            .optional()
            .nullable(),
          scheduledDeliveryConfig: z
            .object({
              days: z
                .object({
                  monday: z
                    .object({
                      enabledForDelivery: z
                        .boolean()
                        .describe(
                          'Shows whether this day slot is enabled for delivery'
                        )
                        .optional()
                        .nullable(),
                      timeSlots: z
                        .array(
                          z.object({
                            from: z
                              .object({
                                hours: z
                                  .number()
                                  .int()
                                  .describe('Hours in format 0-23')
                                  .min(0)
                                  .max(23)
                                  .optional()
                                  .nullable(),
                                minutes: z
                                  .number()
                                  .int()
                                  .describe('Minutes 0-59')
                                  .min(0)
                                  .max(59)
                                  .optional()
                                  .nullable(),
                              })
                              .describe('Starting time point of time slot')
                              .optional(),
                            to: z
                              .object({
                                hours: z
                                  .number()
                                  .int()
                                  .describe('Hours in format 0-23')
                                  .min(0)
                                  .max(23)
                                  .optional()
                                  .nullable(),
                                minutes: z
                                  .number()
                                  .int()
                                  .describe('Minutes 0-59')
                                  .min(0)
                                  .max(59)
                                  .optional()
                                  .nullable(),
                              })
                              .describe('End time point of time slot')
                              .optional(),
                          })
                        )
                        .min(0)
                        .max(8)
                        .optional(),
                    })
                    .optional(),
                  tuesday: z
                    .object({
                      enabledForDelivery: z
                        .boolean()
                        .describe(
                          'Shows whether this day slot is enabled for delivery'
                        )
                        .optional()
                        .nullable(),
                      timeSlots: z
                        .array(
                          z.object({
                            from: z
                              .object({
                                hours: z
                                  .number()
                                  .int()
                                  .describe('Hours in format 0-23')
                                  .min(0)
                                  .max(23)
                                  .optional()
                                  .nullable(),
                                minutes: z
                                  .number()
                                  .int()
                                  .describe('Minutes 0-59')
                                  .min(0)
                                  .max(59)
                                  .optional()
                                  .nullable(),
                              })
                              .describe('Starting time point of time slot')
                              .optional(),
                            to: z
                              .object({
                                hours: z
                                  .number()
                                  .int()
                                  .describe('Hours in format 0-23')
                                  .min(0)
                                  .max(23)
                                  .optional()
                                  .nullable(),
                                minutes: z
                                  .number()
                                  .int()
                                  .describe('Minutes 0-59')
                                  .min(0)
                                  .max(59)
                                  .optional()
                                  .nullable(),
                              })
                              .describe('End time point of time slot')
                              .optional(),
                          })
                        )
                        .min(0)
                        .max(8)
                        .optional(),
                    })
                    .optional(),
                  wednesday: z
                    .object({
                      enabledForDelivery: z
                        .boolean()
                        .describe(
                          'Shows whether this day slot is enabled for delivery'
                        )
                        .optional()
                        .nullable(),
                      timeSlots: z
                        .array(
                          z.object({
                            from: z
                              .object({
                                hours: z
                                  .number()
                                  .int()
                                  .describe('Hours in format 0-23')
                                  .min(0)
                                  .max(23)
                                  .optional()
                                  .nullable(),
                                minutes: z
                                  .number()
                                  .int()
                                  .describe('Minutes 0-59')
                                  .min(0)
                                  .max(59)
                                  .optional()
                                  .nullable(),
                              })
                              .describe('Starting time point of time slot')
                              .optional(),
                            to: z
                              .object({
                                hours: z
                                  .number()
                                  .int()
                                  .describe('Hours in format 0-23')
                                  .min(0)
                                  .max(23)
                                  .optional()
                                  .nullable(),
                                minutes: z
                                  .number()
                                  .int()
                                  .describe('Minutes 0-59')
                                  .min(0)
                                  .max(59)
                                  .optional()
                                  .nullable(),
                              })
                              .describe('End time point of time slot')
                              .optional(),
                          })
                        )
                        .min(0)
                        .max(8)
                        .optional(),
                    })
                    .optional(),
                  thursday: z
                    .object({
                      enabledForDelivery: z
                        .boolean()
                        .describe(
                          'Shows whether this day slot is enabled for delivery'
                        )
                        .optional()
                        .nullable(),
                      timeSlots: z
                        .array(
                          z.object({
                            from: z
                              .object({
                                hours: z
                                  .number()
                                  .int()
                                  .describe('Hours in format 0-23')
                                  .min(0)
                                  .max(23)
                                  .optional()
                                  .nullable(),
                                minutes: z
                                  .number()
                                  .int()
                                  .describe('Minutes 0-59')
                                  .min(0)
                                  .max(59)
                                  .optional()
                                  .nullable(),
                              })
                              .describe('Starting time point of time slot')
                              .optional(),
                            to: z
                              .object({
                                hours: z
                                  .number()
                                  .int()
                                  .describe('Hours in format 0-23')
                                  .min(0)
                                  .max(23)
                                  .optional()
                                  .nullable(),
                                minutes: z
                                  .number()
                                  .int()
                                  .describe('Minutes 0-59')
                                  .min(0)
                                  .max(59)
                                  .optional()
                                  .nullable(),
                              })
                              .describe('End time point of time slot')
                              .optional(),
                          })
                        )
                        .min(0)
                        .max(8)
                        .optional(),
                    })
                    .optional(),
                  friday: z
                    .object({
                      enabledForDelivery: z
                        .boolean()
                        .describe(
                          'Shows whether this day slot is enabled for delivery'
                        )
                        .optional()
                        .nullable(),
                      timeSlots: z
                        .array(
                          z.object({
                            from: z
                              .object({
                                hours: z
                                  .number()
                                  .int()
                                  .describe('Hours in format 0-23')
                                  .min(0)
                                  .max(23)
                                  .optional()
                                  .nullable(),
                                minutes: z
                                  .number()
                                  .int()
                                  .describe('Minutes 0-59')
                                  .min(0)
                                  .max(59)
                                  .optional()
                                  .nullable(),
                              })
                              .describe('Starting time point of time slot')
                              .optional(),
                            to: z
                              .object({
                                hours: z
                                  .number()
                                  .int()
                                  .describe('Hours in format 0-23')
                                  .min(0)
                                  .max(23)
                                  .optional()
                                  .nullable(),
                                minutes: z
                                  .number()
                                  .int()
                                  .describe('Minutes 0-59')
                                  .min(0)
                                  .max(59)
                                  .optional()
                                  .nullable(),
                              })
                              .describe('End time point of time slot')
                              .optional(),
                          })
                        )
                        .min(0)
                        .max(8)
                        .optional(),
                    })
                    .optional(),
                  saturday: z
                    .object({
                      enabledForDelivery: z
                        .boolean()
                        .describe(
                          'Shows whether this day slot is enabled for delivery'
                        )
                        .optional()
                        .nullable(),
                      timeSlots: z
                        .array(
                          z.object({
                            from: z
                              .object({
                                hours: z
                                  .number()
                                  .int()
                                  .describe('Hours in format 0-23')
                                  .min(0)
                                  .max(23)
                                  .optional()
                                  .nullable(),
                                minutes: z
                                  .number()
                                  .int()
                                  .describe('Minutes 0-59')
                                  .min(0)
                                  .max(59)
                                  .optional()
                                  .nullable(),
                              })
                              .describe('Starting time point of time slot')
                              .optional(),
                            to: z
                              .object({
                                hours: z
                                  .number()
                                  .int()
                                  .describe('Hours in format 0-23')
                                  .min(0)
                                  .max(23)
                                  .optional()
                                  .nullable(),
                                minutes: z
                                  .number()
                                  .int()
                                  .describe('Minutes 0-59')
                                  .min(0)
                                  .max(59)
                                  .optional()
                                  .nullable(),
                              })
                              .describe('End time point of time slot')
                              .optional(),
                          })
                        )
                        .min(0)
                        .max(8)
                        .optional(),
                    })
                    .optional(),
                  sunday: z
                    .object({
                      enabledForDelivery: z
                        .boolean()
                        .describe(
                          'Shows whether this day slot is enabled for delivery'
                        )
                        .optional()
                        .nullable(),
                      timeSlots: z
                        .array(
                          z.object({
                            from: z
                              .object({
                                hours: z
                                  .number()
                                  .int()
                                  .describe('Hours in format 0-23')
                                  .min(0)
                                  .max(23)
                                  .optional()
                                  .nullable(),
                                minutes: z
                                  .number()
                                  .int()
                                  .describe('Minutes 0-59')
                                  .min(0)
                                  .max(59)
                                  .optional()
                                  .nullable(),
                              })
                              .describe('Starting time point of time slot')
                              .optional(),
                            to: z
                              .object({
                                hours: z
                                  .number()
                                  .int()
                                  .describe('Hours in format 0-23')
                                  .min(0)
                                  .max(23)
                                  .optional()
                                  .nullable(),
                                minutes: z
                                  .number()
                                  .int()
                                  .describe('Minutes 0-59')
                                  .min(0)
                                  .max(59)
                                  .optional()
                                  .nullable(),
                              })
                              .describe('End time point of time slot')
                              .optional(),
                          })
                        )
                        .min(0)
                        .max(8)
                        .optional(),
                    })
                    .optional(),
                })
                .describe(
                  "Days config which contain days when delivery is enabled with it's time slots"
                )
                .optional(),
              handlingDays: z
                .number()
                .int()
                .describe('Amount of days before first delivery option date')
                .min(0)
                .max(30)
                .optional()
                .nullable(),
              cutOffTime: z
                .object({
                  hours: z
                    .number()
                    .int()
                    .describe('Hours in format 0-23')
                    .min(0)
                    .max(23)
                    .optional()
                    .nullable(),
                  minutes: z
                    .number()
                    .int()
                    .describe('Minutes 0-59')
                    .min(0)
                    .max(59)
                    .optional()
                    .nullable(),
                })
                .describe(
                  'Cut off time after which first delivery option would be for next day'
                )
                .optional(),
              timeWindows: z
                .array(
                  z.object({
                    day: z
                      .enum(['MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT', 'SUN'])
                      .describe('The day of week this availability relates to.')
                      .optional(),
                    start: z
                      .object({
                        hours: z
                          .number()
                          .int()
                          .describe('Hours')
                          .min(0)
                          .max(23)
                          .optional(),
                        minutes: z
                          .number()
                          .int()
                          .describe('Minutes')
                          .min(0)
                          .max(59)
                          .optional(),
                      })
                      .describe('The start time in time of day representation.')
                      .optional(),
                    end: z
                      .object({
                        hours: z
                          .number()
                          .int()
                          .describe('Hours')
                          .min(0)
                          .max(23)
                          .optional(),
                        minutes: z
                          .number()
                          .int()
                          .describe('Minutes')
                          .min(0)
                          .max(59)
                          .optional(),
                      })
                      .describe('The end time in time of day representation.')
                      .optional(),
                    enabled: z
                      .boolean()
                      .describe(
                        'Whether this timeWindow availability is enabled.'
                      )
                      .optional()
                      .nullable(),
                  })
                )
                .min(0)
                .max(100)
                .optional(),
            })
            .optional(),
          rates: z
            .array(
              z.object({
                amount: z
                  .string()
                  .describe(
                    'there is an AND logic between all the conditions. Empty conditions means true.\nThe amount of the rate that will be returned if all conditions are met.'
                  )
                  .optional(),
                conditions: z
                  .array(
                    z.object({
                      type: z
                        .enum([
                          'BY_TOTAL_WEIGHT',
                          'BY_TOTAL_PRICE',
                          'BY_TOTAL_QUANTITY',
                        ])
                        .optional(),
                      value: z
                        .string()
                        .describe(
                          'The value in respective to the condition type\nWeight values should be in the same weight units of the store: KG / LB\nTotal price is according to the store currency\nQuantity of items should be integers'
                        )
                        .optional(),
                      operator: z
                        .enum(['EQ', 'GT', 'GTE', 'LT', 'LTE'])
                        .describe('Logical operator.')
                        .optional(),
                    })
                  )
                  .min(0)
                  .max(10)
                  .optional(),
                multiplyByQuantity: z
                  .boolean()
                  .describe(
                    'When this flag is set to true, multiply the amount by the number of line items passed on the request.'
                  )
                  .optional(),
              })
            )
            .max(50)
            .optional(),
          _createdDate: z
            .date()
            .describe('Date and time the LocalDeliveryOption was created.')
            .optional()
            .nullable(),
          _updatedDate: z
            .date()
            .describe('Date and time the LocalDeliveryOption was last updated.')
            .optional()
            .nullable(),
          deliveryRegionIds: z.array(z.string()).max(50).optional(),
        }),
        z.xor([
          z.object({
            zipConfig: z.never().optional(),
            radiusConfig: z.never().optional(),
            customAreaConfig: z.never().optional(),
            cityConfig: z.never().optional(),
          }),
          z.object({
            radiusConfig: z.never().optional(),
            customAreaConfig: z.never().optional(),
            cityConfig: z.never().optional(),
            zipConfig: z.object({ zipCodes: z.array(z.string()).optional() }),
          }),
          z.object({
            zipConfig: z.never().optional(),
            customAreaConfig: z.never().optional(),
            cityConfig: z.never().optional(),
            radiusConfig: z.object({
              radius: z
                .number()
                .describe("Delivery circle's radius")
                .min(0.1)
                .max(50)
                .optional(),
              lengthUnit: z
                .enum(['UNSPECIFIED_LENGTH_UNIT', 'KM', 'MI'])
                .describe("Radius' unit, taken from site properties")
                .optional(),
            }),
          }),
          z.object({
            zipConfig: z.never().optional(),
            radiusConfig: z.never().optional(),
            cityConfig: z.never().optional(),
            customAreaConfig: z.object({
              geocodes: z
                .array(
                  z.object({
                    latitude: z
                      .number()
                      .describe('Address latitude.')
                      .optional()
                      .nullable(),
                    longitude: z
                      .number()
                      .describe('Address longitude.')
                      .optional()
                      .nullable(),
                  })
                )
                .max(300)
                .optional(),
            }),
          }),
          z.object({
            zipConfig: z.never().optional(),
            radiusConfig: z.never().optional(),
            customAreaConfig: z.never().optional(),
            cityConfig: z.object({
              cityItems: z
                .array(
                  z.object({
                    cityName: z
                      .string()
                      .describe('Name of the city')
                      .min(1)
                      .max(100)
                      .optional(),
                    subdivision: z
                      .string()
                      .describe('Subdivision code of the city')
                      .optional()
                      .nullable(),
                    country: z
                      .string()
                      .describe('Country code of the city')
                      .optional(),
                    cityKey: z
                      .string()
                      .describe('Unique code of the city, calculated by Wix')
                      .max(100)
                      .optional()
                      .nullable(),
                  })
                )
                .min(1)
                .max(50)
                .optional(),
            }),
          }),
        ])
      )
    )
    .optional(),
});
export const QueryLocalDeliveryOptionsRequest = z.object({
  query: z
    .intersection(
      z.object({
        filter: z
          .record(z.string(), z.any())
          .describe(
            'Filter object.\n\nLearn more about the [filter section](https://dev.wix.com/docs/rest/articles/getting-started/api-query-language#the-filter-section).'
          )
          .optional()
          .nullable(),
        sort: z
          .array(
            z.object({
              fieldName: z
                .string()
                .describe('Name of the field to sort by.')
                .max(512)
                .optional(),
              order: z.enum(['ASC', 'DESC']).optional(),
            })
          )
          .max(5)
          .optional(),
      }),
      z.xor([
        z.object({
          paging: z.never().optional(),
          cursorPaging: z.never().optional(),
        }),
        z.object({
          cursorPaging: z.never().optional(),
          paging: z
            .object({
              limit: z
                .number()
                .int()
                .describe('Number of items to load.')
                .min(0)
                .optional()
                .nullable(),
              offset: z
                .number()
                .int()
                .describe('Number of items to skip in the current sort order.')
                .min(0)
                .optional()
                .nullable(),
            })
            .describe('Paging options to limit and skip the number of items.'),
        }),
        z.object({
          paging: z.never().optional(),
          cursorPaging: z
            .object({
              limit: z
                .number()
                .int()
                .describe('Maximum number of items to return in the results.')
                .min(0)
                .max(100)
                .optional()
                .nullable(),
              cursor: z
                .string()
                .describe(
                  "Pointer to the next or previous page in the list of results.\n\nPass the relevant cursor token from the `pagingMetadata` object in the previous call's response.\nNot relevant for the first request."
                )
                .max(16000)
                .optional()
                .nullable(),
            })
            .describe(
              'Cursor token pointing to a page of results. Not used in the first request. Following requests use the cursor token and not `filter` or `sort`.'
            ),
        }),
      ])
    )
    .describe('WQL expression'),
});
export const QueryLocalDeliveryOptionsResponse = z.object({
  localDeliveryOptions: z
    .array(
      z.intersection(
        z.object({
          _id: z
            .string()
            .describe(
              'LocalDeliveryOptionId - unique identifier of local delivery option'
            )
            .regex(
              /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
              'Must be a valid GUID'
            )
            .optional()
            .nullable(),
          areaName: z
            .string()
            .describe('Area name of Local Delivery Option')
            .max(100)
            .optional()
            .nullable(),
          rate: z
            .string()
            .describe('Flat price of local delivery')
            .optional()
            .nullable(),
          estimatedDeliveryTime: z
            .string()
            .describe('Estimated delivery time description text')
            .max(40)
            .optional()
            .nullable(),
          minimumFreeDeliveryOrderAmount: z
            .number()
            .describe('Minimum order total to be eligible for free delivery')
            .optional()
            .nullable(),
          destinations: z
            .array(
              z.object({
                code: z.string().describe('Country ISO code').optional(),
                subdivisions: z.array(z.string()).max(200).optional(),
              })
            )
            .min(0)
            .max(100)
            .optional(),
          revision: z
            .string()
            .regex(/^\d+$/, 'Must be a valid UInt64 string')
            .describe(
              'Database revision of LocalDeliveryOption entity. Incremented on each modification'
            )
            .optional()
            .nullable(),
          scheduledDeliveryConfig: z
            .object({
              days: z
                .object({
                  monday: z
                    .object({
                      enabledForDelivery: z
                        .boolean()
                        .describe(
                          'Shows whether this day slot is enabled for delivery'
                        )
                        .optional()
                        .nullable(),
                      timeSlots: z
                        .array(
                          z.object({
                            from: z
                              .object({
                                hours: z
                                  .number()
                                  .int()
                                  .describe('Hours in format 0-23')
                                  .min(0)
                                  .max(23)
                                  .optional()
                                  .nullable(),
                                minutes: z
                                  .number()
                                  .int()
                                  .describe('Minutes 0-59')
                                  .min(0)
                                  .max(59)
                                  .optional()
                                  .nullable(),
                              })
                              .describe('Starting time point of time slot')
                              .optional(),
                            to: z
                              .object({
                                hours: z
                                  .number()
                                  .int()
                                  .describe('Hours in format 0-23')
                                  .min(0)
                                  .max(23)
                                  .optional()
                                  .nullable(),
                                minutes: z
                                  .number()
                                  .int()
                                  .describe('Minutes 0-59')
                                  .min(0)
                                  .max(59)
                                  .optional()
                                  .nullable(),
                              })
                              .describe('End time point of time slot')
                              .optional(),
                          })
                        )
                        .min(0)
                        .max(8)
                        .optional(),
                    })
                    .optional(),
                  tuesday: z
                    .object({
                      enabledForDelivery: z
                        .boolean()
                        .describe(
                          'Shows whether this day slot is enabled for delivery'
                        )
                        .optional()
                        .nullable(),
                      timeSlots: z
                        .array(
                          z.object({
                            from: z
                              .object({
                                hours: z
                                  .number()
                                  .int()
                                  .describe('Hours in format 0-23')
                                  .min(0)
                                  .max(23)
                                  .optional()
                                  .nullable(),
                                minutes: z
                                  .number()
                                  .int()
                                  .describe('Minutes 0-59')
                                  .min(0)
                                  .max(59)
                                  .optional()
                                  .nullable(),
                              })
                              .describe('Starting time point of time slot')
                              .optional(),
                            to: z
                              .object({
                                hours: z
                                  .number()
                                  .int()
                                  .describe('Hours in format 0-23')
                                  .min(0)
                                  .max(23)
                                  .optional()
                                  .nullable(),
                                minutes: z
                                  .number()
                                  .int()
                                  .describe('Minutes 0-59')
                                  .min(0)
                                  .max(59)
                                  .optional()
                                  .nullable(),
                              })
                              .describe('End time point of time slot')
                              .optional(),
                          })
                        )
                        .min(0)
                        .max(8)
                        .optional(),
                    })
                    .optional(),
                  wednesday: z
                    .object({
                      enabledForDelivery: z
                        .boolean()
                        .describe(
                          'Shows whether this day slot is enabled for delivery'
                        )
                        .optional()
                        .nullable(),
                      timeSlots: z
                        .array(
                          z.object({
                            from: z
                              .object({
                                hours: z
                                  .number()
                                  .int()
                                  .describe('Hours in format 0-23')
                                  .min(0)
                                  .max(23)
                                  .optional()
                                  .nullable(),
                                minutes: z
                                  .number()
                                  .int()
                                  .describe('Minutes 0-59')
                                  .min(0)
                                  .max(59)
                                  .optional()
                                  .nullable(),
                              })
                              .describe('Starting time point of time slot')
                              .optional(),
                            to: z
                              .object({
                                hours: z
                                  .number()
                                  .int()
                                  .describe('Hours in format 0-23')
                                  .min(0)
                                  .max(23)
                                  .optional()
                                  .nullable(),
                                minutes: z
                                  .number()
                                  .int()
                                  .describe('Minutes 0-59')
                                  .min(0)
                                  .max(59)
                                  .optional()
                                  .nullable(),
                              })
                              .describe('End time point of time slot')
                              .optional(),
                          })
                        )
                        .min(0)
                        .max(8)
                        .optional(),
                    })
                    .optional(),
                  thursday: z
                    .object({
                      enabledForDelivery: z
                        .boolean()
                        .describe(
                          'Shows whether this day slot is enabled for delivery'
                        )
                        .optional()
                        .nullable(),
                      timeSlots: z
                        .array(
                          z.object({
                            from: z
                              .object({
                                hours: z
                                  .number()
                                  .int()
                                  .describe('Hours in format 0-23')
                                  .min(0)
                                  .max(23)
                                  .optional()
                                  .nullable(),
                                minutes: z
                                  .number()
                                  .int()
                                  .describe('Minutes 0-59')
                                  .min(0)
                                  .max(59)
                                  .optional()
                                  .nullable(),
                              })
                              .describe('Starting time point of time slot')
                              .optional(),
                            to: z
                              .object({
                                hours: z
                                  .number()
                                  .int()
                                  .describe('Hours in format 0-23')
                                  .min(0)
                                  .max(23)
                                  .optional()
                                  .nullable(),
                                minutes: z
                                  .number()
                                  .int()
                                  .describe('Minutes 0-59')
                                  .min(0)
                                  .max(59)
                                  .optional()
                                  .nullable(),
                              })
                              .describe('End time point of time slot')
                              .optional(),
                          })
                        )
                        .min(0)
                        .max(8)
                        .optional(),
                    })
                    .optional(),
                  friday: z
                    .object({
                      enabledForDelivery: z
                        .boolean()
                        .describe(
                          'Shows whether this day slot is enabled for delivery'
                        )
                        .optional()
                        .nullable(),
                      timeSlots: z
                        .array(
                          z.object({
                            from: z
                              .object({
                                hours: z
                                  .number()
                                  .int()
                                  .describe('Hours in format 0-23')
                                  .min(0)
                                  .max(23)
                                  .optional()
                                  .nullable(),
                                minutes: z
                                  .number()
                                  .int()
                                  .describe('Minutes 0-59')
                                  .min(0)
                                  .max(59)
                                  .optional()
                                  .nullable(),
                              })
                              .describe('Starting time point of time slot')
                              .optional(),
                            to: z
                              .object({
                                hours: z
                                  .number()
                                  .int()
                                  .describe('Hours in format 0-23')
                                  .min(0)
                                  .max(23)
                                  .optional()
                                  .nullable(),
                                minutes: z
                                  .number()
                                  .int()
                                  .describe('Minutes 0-59')
                                  .min(0)
                                  .max(59)
                                  .optional()
                                  .nullable(),
                              })
                              .describe('End time point of time slot')
                              .optional(),
                          })
                        )
                        .min(0)
                        .max(8)
                        .optional(),
                    })
                    .optional(),
                  saturday: z
                    .object({
                      enabledForDelivery: z
                        .boolean()
                        .describe(
                          'Shows whether this day slot is enabled for delivery'
                        )
                        .optional()
                        .nullable(),
                      timeSlots: z
                        .array(
                          z.object({
                            from: z
                              .object({
                                hours: z
                                  .number()
                                  .int()
                                  .describe('Hours in format 0-23')
                                  .min(0)
                                  .max(23)
                                  .optional()
                                  .nullable(),
                                minutes: z
                                  .number()
                                  .int()
                                  .describe('Minutes 0-59')
                                  .min(0)
                                  .max(59)
                                  .optional()
                                  .nullable(),
                              })
                              .describe('Starting time point of time slot')
                              .optional(),
                            to: z
                              .object({
                                hours: z
                                  .number()
                                  .int()
                                  .describe('Hours in format 0-23')
                                  .min(0)
                                  .max(23)
                                  .optional()
                                  .nullable(),
                                minutes: z
                                  .number()
                                  .int()
                                  .describe('Minutes 0-59')
                                  .min(0)
                                  .max(59)
                                  .optional()
                                  .nullable(),
                              })
                              .describe('End time point of time slot')
                              .optional(),
                          })
                        )
                        .min(0)
                        .max(8)
                        .optional(),
                    })
                    .optional(),
                  sunday: z
                    .object({
                      enabledForDelivery: z
                        .boolean()
                        .describe(
                          'Shows whether this day slot is enabled for delivery'
                        )
                        .optional()
                        .nullable(),
                      timeSlots: z
                        .array(
                          z.object({
                            from: z
                              .object({
                                hours: z
                                  .number()
                                  .int()
                                  .describe('Hours in format 0-23')
                                  .min(0)
                                  .max(23)
                                  .optional()
                                  .nullable(),
                                minutes: z
                                  .number()
                                  .int()
                                  .describe('Minutes 0-59')
                                  .min(0)
                                  .max(59)
                                  .optional()
                                  .nullable(),
                              })
                              .describe('Starting time point of time slot')
                              .optional(),
                            to: z
                              .object({
                                hours: z
                                  .number()
                                  .int()
                                  .describe('Hours in format 0-23')
                                  .min(0)
                                  .max(23)
                                  .optional()
                                  .nullable(),
                                minutes: z
                                  .number()
                                  .int()
                                  .describe('Minutes 0-59')
                                  .min(0)
                                  .max(59)
                                  .optional()
                                  .nullable(),
                              })
                              .describe('End time point of time slot')
                              .optional(),
                          })
                        )
                        .min(0)
                        .max(8)
                        .optional(),
                    })
                    .optional(),
                })
                .describe(
                  "Days config which contain days when delivery is enabled with it's time slots"
                )
                .optional(),
              handlingDays: z
                .number()
                .int()
                .describe('Amount of days before first delivery option date')
                .min(0)
                .max(30)
                .optional()
                .nullable(),
              cutOffTime: z
                .object({
                  hours: z
                    .number()
                    .int()
                    .describe('Hours in format 0-23')
                    .min(0)
                    .max(23)
                    .optional()
                    .nullable(),
                  minutes: z
                    .number()
                    .int()
                    .describe('Minutes 0-59')
                    .min(0)
                    .max(59)
                    .optional()
                    .nullable(),
                })
                .describe(
                  'Cut off time after which first delivery option would be for next day'
                )
                .optional(),
              timeWindows: z
                .array(
                  z.object({
                    day: z
                      .enum(['MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT', 'SUN'])
                      .describe('The day of week this availability relates to.')
                      .optional(),
                    start: z
                      .object({
                        hours: z
                          .number()
                          .int()
                          .describe('Hours')
                          .min(0)
                          .max(23)
                          .optional(),
                        minutes: z
                          .number()
                          .int()
                          .describe('Minutes')
                          .min(0)
                          .max(59)
                          .optional(),
                      })
                      .describe('The start time in time of day representation.')
                      .optional(),
                    end: z
                      .object({
                        hours: z
                          .number()
                          .int()
                          .describe('Hours')
                          .min(0)
                          .max(23)
                          .optional(),
                        minutes: z
                          .number()
                          .int()
                          .describe('Minutes')
                          .min(0)
                          .max(59)
                          .optional(),
                      })
                      .describe('The end time in time of day representation.')
                      .optional(),
                    enabled: z
                      .boolean()
                      .describe(
                        'Whether this timeWindow availability is enabled.'
                      )
                      .optional()
                      .nullable(),
                  })
                )
                .min(0)
                .max(100)
                .optional(),
            })
            .optional(),
          rates: z
            .array(
              z.object({
                amount: z
                  .string()
                  .describe(
                    'there is an AND logic between all the conditions. Empty conditions means true.\nThe amount of the rate that will be returned if all conditions are met.'
                  )
                  .optional(),
                conditions: z
                  .array(
                    z.object({
                      type: z
                        .enum([
                          'BY_TOTAL_WEIGHT',
                          'BY_TOTAL_PRICE',
                          'BY_TOTAL_QUANTITY',
                        ])
                        .optional(),
                      value: z
                        .string()
                        .describe(
                          'The value in respective to the condition type\nWeight values should be in the same weight units of the store: KG / LB\nTotal price is according to the store currency\nQuantity of items should be integers'
                        )
                        .optional(),
                      operator: z
                        .enum(['EQ', 'GT', 'GTE', 'LT', 'LTE'])
                        .describe('Logical operator.')
                        .optional(),
                    })
                  )
                  .min(0)
                  .max(10)
                  .optional(),
                multiplyByQuantity: z
                  .boolean()
                  .describe(
                    'When this flag is set to true, multiply the amount by the number of line items passed on the request.'
                  )
                  .optional(),
              })
            )
            .max(50)
            .optional(),
          _createdDate: z
            .date()
            .describe('Date and time the LocalDeliveryOption was created.')
            .optional()
            .nullable(),
          _updatedDate: z
            .date()
            .describe('Date and time the LocalDeliveryOption was last updated.')
            .optional()
            .nullable(),
          deliveryRegionIds: z.array(z.string()).max(50).optional(),
        }),
        z.xor([
          z.object({
            zipConfig: z.never().optional(),
            radiusConfig: z.never().optional(),
            customAreaConfig: z.never().optional(),
            cityConfig: z.never().optional(),
          }),
          z.object({
            radiusConfig: z.never().optional(),
            customAreaConfig: z.never().optional(),
            cityConfig: z.never().optional(),
            zipConfig: z.object({ zipCodes: z.array(z.string()).optional() }),
          }),
          z.object({
            zipConfig: z.never().optional(),
            customAreaConfig: z.never().optional(),
            cityConfig: z.never().optional(),
            radiusConfig: z.object({
              radius: z
                .number()
                .describe("Delivery circle's radius")
                .min(0.1)
                .max(50)
                .optional(),
              lengthUnit: z
                .enum(['UNSPECIFIED_LENGTH_UNIT', 'KM', 'MI'])
                .describe("Radius' unit, taken from site properties")
                .optional(),
            }),
          }),
          z.object({
            zipConfig: z.never().optional(),
            radiusConfig: z.never().optional(),
            cityConfig: z.never().optional(),
            customAreaConfig: z.object({
              geocodes: z
                .array(
                  z.object({
                    latitude: z
                      .number()
                      .describe('Address latitude.')
                      .optional()
                      .nullable(),
                    longitude: z
                      .number()
                      .describe('Address longitude.')
                      .optional()
                      .nullable(),
                  })
                )
                .max(300)
                .optional(),
            }),
          }),
          z.object({
            zipConfig: z.never().optional(),
            radiusConfig: z.never().optional(),
            customAreaConfig: z.never().optional(),
            cityConfig: z.object({
              cityItems: z
                .array(
                  z.object({
                    cityName: z
                      .string()
                      .describe('Name of the city')
                      .min(1)
                      .max(100)
                      .optional(),
                    subdivision: z
                      .string()
                      .describe('Subdivision code of the city')
                      .optional()
                      .nullable(),
                    country: z
                      .string()
                      .describe('Country code of the city')
                      .optional(),
                    cityKey: z
                      .string()
                      .describe('Unique code of the city, calculated by Wix')
                      .max(100)
                      .optional()
                      .nullable(),
                  })
                )
                .min(1)
                .max(50)
                .optional(),
            }),
          }),
        ])
      )
    )
    .optional(),
  pagingMetadata: z
    .object({
      count: z
        .number()
        .int()
        .describe('Number of items returned in current page.')
        .optional()
        .nullable(),
      cursors: z
        .object({
          next: z
            .string()
            .describe(
              'Cursor string pointing to the next page in the list of results.'
            )
            .max(16000)
            .optional()
            .nullable(),
          prev: z
            .string()
            .describe(
              'Cursor pointing to the previous page in the list of results.'
            )
            .max(16000)
            .optional()
            .nullable(),
        })
        .describe(
          'Cursor strings that point to the next page, previous page, or both.'
        )
        .optional(),
      hasNext: z
        .boolean()
        .describe(
          'Whether there are more pages to retrieve following the current page.\n\n+ `true`: Another page of results can be retrieved.\n+ `false`: This is the last page.'
        )
        .optional()
        .nullable(),
    })
    .describe('Paging metadata.')
    .optional(),
});
export const UpdateLocalDeliveryOptionRequest = z.object({
  _id: z
    .string()
    .describe(
      'LocalDeliveryOptionId - unique identifier of local delivery option'
    )
    .regex(
      /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
      'Must be a valid GUID'
    ),
  localDeliveryOption: z
    .intersection(
      z.object({
        _id: z
          .string()
          .describe(
            'LocalDeliveryOptionId - unique identifier of local delivery option'
          )
          .regex(
            /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
            'Must be a valid GUID'
          )
          .optional()
          .nullable(),
        areaName: z
          .string()
          .describe('Area name of Local Delivery Option')
          .max(100)
          .optional()
          .nullable(),
        rate: z
          .string()
          .describe('Flat price of local delivery')
          .optional()
          .nullable(),
        estimatedDeliveryTime: z
          .string()
          .describe('Estimated delivery time description text')
          .max(40)
          .optional()
          .nullable(),
        minimumFreeDeliveryOrderAmount: z
          .number()
          .describe('Minimum order total to be eligible for free delivery')
          .optional()
          .nullable(),
        destinations: z
          .array(
            z.object({
              code: z.string().describe('Country ISO code').optional(),
              subdivisions: z.array(z.string()).max(200).optional(),
            })
          )
          .min(0)
          .max(100)
          .optional(),
        revision: z
          .string()
          .regex(/^\d+$/, 'Must be a valid UInt64 string')
          .describe(
            'Database revision of LocalDeliveryOption entity. Incremented on each modification'
          )
          .optional()
          .nullable(),
        scheduledDeliveryConfig: z
          .object({
            days: z
              .object({
                monday: z
                  .object({
                    enabledForDelivery: z
                      .boolean()
                      .describe(
                        'Shows whether this day slot is enabled for delivery'
                      ),
                    timeSlots: z
                      .array(
                        z.object({
                          from: z
                            .object({
                              hours: z
                                .number()
                                .int()
                                .describe('Hours in format 0-23')
                                .min(0)
                                .max(23),
                              minutes: z
                                .number()
                                .int()
                                .describe('Minutes 0-59')
                                .min(0)
                                .max(59),
                            })
                            .describe('Starting time point of time slot'),
                          to: z
                            .object({
                              hours: z
                                .number()
                                .int()
                                .describe('Hours in format 0-23')
                                .min(0)
                                .max(23),
                              minutes: z
                                .number()
                                .int()
                                .describe('Minutes 0-59')
                                .min(0)
                                .max(59),
                            })
                            .describe('End time point of time slot'),
                        })
                      )
                      .min(0)
                      .max(8)
                      .optional(),
                  })
                  .optional(),
                tuesday: z
                  .object({
                    enabledForDelivery: z
                      .boolean()
                      .describe(
                        'Shows whether this day slot is enabled for delivery'
                      ),
                    timeSlots: z
                      .array(
                        z.object({
                          from: z
                            .object({
                              hours: z
                                .number()
                                .int()
                                .describe('Hours in format 0-23')
                                .min(0)
                                .max(23),
                              minutes: z
                                .number()
                                .int()
                                .describe('Minutes 0-59')
                                .min(0)
                                .max(59),
                            })
                            .describe('Starting time point of time slot'),
                          to: z
                            .object({
                              hours: z
                                .number()
                                .int()
                                .describe('Hours in format 0-23')
                                .min(0)
                                .max(23),
                              minutes: z
                                .number()
                                .int()
                                .describe('Minutes 0-59')
                                .min(0)
                                .max(59),
                            })
                            .describe('End time point of time slot'),
                        })
                      )
                      .min(0)
                      .max(8)
                      .optional(),
                  })
                  .optional(),
                wednesday: z
                  .object({
                    enabledForDelivery: z
                      .boolean()
                      .describe(
                        'Shows whether this day slot is enabled for delivery'
                      ),
                    timeSlots: z
                      .array(
                        z.object({
                          from: z
                            .object({
                              hours: z
                                .number()
                                .int()
                                .describe('Hours in format 0-23')
                                .min(0)
                                .max(23),
                              minutes: z
                                .number()
                                .int()
                                .describe('Minutes 0-59')
                                .min(0)
                                .max(59),
                            })
                            .describe('Starting time point of time slot'),
                          to: z
                            .object({
                              hours: z
                                .number()
                                .int()
                                .describe('Hours in format 0-23')
                                .min(0)
                                .max(23),
                              minutes: z
                                .number()
                                .int()
                                .describe('Minutes 0-59')
                                .min(0)
                                .max(59),
                            })
                            .describe('End time point of time slot'),
                        })
                      )
                      .min(0)
                      .max(8)
                      .optional(),
                  })
                  .optional(),
                thursday: z
                  .object({
                    enabledForDelivery: z
                      .boolean()
                      .describe(
                        'Shows whether this day slot is enabled for delivery'
                      ),
                    timeSlots: z
                      .array(
                        z.object({
                          from: z
                            .object({
                              hours: z
                                .number()
                                .int()
                                .describe('Hours in format 0-23')
                                .min(0)
                                .max(23),
                              minutes: z
                                .number()
                                .int()
                                .describe('Minutes 0-59')
                                .min(0)
                                .max(59),
                            })
                            .describe('Starting time point of time slot'),
                          to: z
                            .object({
                              hours: z
                                .number()
                                .int()
                                .describe('Hours in format 0-23')
                                .min(0)
                                .max(23),
                              minutes: z
                                .number()
                                .int()
                                .describe('Minutes 0-59')
                                .min(0)
                                .max(59),
                            })
                            .describe('End time point of time slot'),
                        })
                      )
                      .min(0)
                      .max(8)
                      .optional(),
                  })
                  .optional(),
                friday: z
                  .object({
                    enabledForDelivery: z
                      .boolean()
                      .describe(
                        'Shows whether this day slot is enabled for delivery'
                      ),
                    timeSlots: z
                      .array(
                        z.object({
                          from: z
                            .object({
                              hours: z
                                .number()
                                .int()
                                .describe('Hours in format 0-23')
                                .min(0)
                                .max(23),
                              minutes: z
                                .number()
                                .int()
                                .describe('Minutes 0-59')
                                .min(0)
                                .max(59),
                            })
                            .describe('Starting time point of time slot'),
                          to: z
                            .object({
                              hours: z
                                .number()
                                .int()
                                .describe('Hours in format 0-23')
                                .min(0)
                                .max(23),
                              minutes: z
                                .number()
                                .int()
                                .describe('Minutes 0-59')
                                .min(0)
                                .max(59),
                            })
                            .describe('End time point of time slot'),
                        })
                      )
                      .min(0)
                      .max(8)
                      .optional(),
                  })
                  .optional(),
                saturday: z
                  .object({
                    enabledForDelivery: z
                      .boolean()
                      .describe(
                        'Shows whether this day slot is enabled for delivery'
                      ),
                    timeSlots: z
                      .array(
                        z.object({
                          from: z
                            .object({
                              hours: z
                                .number()
                                .int()
                                .describe('Hours in format 0-23')
                                .min(0)
                                .max(23),
                              minutes: z
                                .number()
                                .int()
                                .describe('Minutes 0-59')
                                .min(0)
                                .max(59),
                            })
                            .describe('Starting time point of time slot'),
                          to: z
                            .object({
                              hours: z
                                .number()
                                .int()
                                .describe('Hours in format 0-23')
                                .min(0)
                                .max(23),
                              minutes: z
                                .number()
                                .int()
                                .describe('Minutes 0-59')
                                .min(0)
                                .max(59),
                            })
                            .describe('End time point of time slot'),
                        })
                      )
                      .min(0)
                      .max(8)
                      .optional(),
                  })
                  .optional(),
                sunday: z
                  .object({
                    enabledForDelivery: z
                      .boolean()
                      .describe(
                        'Shows whether this day slot is enabled for delivery'
                      ),
                    timeSlots: z
                      .array(
                        z.object({
                          from: z
                            .object({
                              hours: z
                                .number()
                                .int()
                                .describe('Hours in format 0-23')
                                .min(0)
                                .max(23),
                              minutes: z
                                .number()
                                .int()
                                .describe('Minutes 0-59')
                                .min(0)
                                .max(59),
                            })
                            .describe('Starting time point of time slot'),
                          to: z
                            .object({
                              hours: z
                                .number()
                                .int()
                                .describe('Hours in format 0-23')
                                .min(0)
                                .max(23),
                              minutes: z
                                .number()
                                .int()
                                .describe('Minutes 0-59')
                                .min(0)
                                .max(59),
                            })
                            .describe('End time point of time slot'),
                        })
                      )
                      .min(0)
                      .max(8)
                      .optional(),
                  })
                  .optional(),
              })
              .describe(
                "Days config which contain days when delivery is enabled with it's time slots"
              )
              .optional(),
            handlingDays: z
              .number()
              .int()
              .describe('Amount of days before first delivery option date')
              .min(0)
              .max(30),
            cutOffTime: z
              .object({
                hours: z
                  .number()
                  .int()
                  .describe('Hours in format 0-23')
                  .min(0)
                  .max(23),
                minutes: z
                  .number()
                  .int()
                  .describe('Minutes 0-59')
                  .min(0)
                  .max(59),
              })
              .describe(
                'Cut off time after which first delivery option would be for next day'
              )
              .optional(),
            timeWindows: z
              .array(
                z.object({
                  day: z
                    .enum(['MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT', 'SUN'])
                    .optional(),
                  start: z
                    .object({
                      hours: z
                        .number()
                        .int()
                        .describe('Hours')
                        .min(0)
                        .max(23)
                        .optional(),
                      minutes: z
                        .number()
                        .int()
                        .describe('Minutes')
                        .min(0)
                        .max(59)
                        .optional(),
                    })
                    .describe('The start time in time of day representation.')
                    .optional(),
                  end: z
                    .object({
                      hours: z
                        .number()
                        .int()
                        .describe('Hours')
                        .min(0)
                        .max(23)
                        .optional(),
                      minutes: z
                        .number()
                        .int()
                        .describe('Minutes')
                        .min(0)
                        .max(59)
                        .optional(),
                    })
                    .describe('The end time in time of day representation.')
                    .optional(),
                  enabled: z
                    .boolean()
                    .describe(
                      'Whether this timeWindow availability is enabled.'
                    )
                    .optional()
                    .nullable(),
                })
              )
              .min(0)
              .max(100)
              .optional(),
          })
          .optional(),
        rates: z
          .array(
            z.object({
              amount: z
                .string()
                .describe(
                  'there is an AND logic between all the conditions. Empty conditions means true.\nThe amount of the rate that will be returned if all conditions are met.'
                )
                .optional(),
              conditions: z
                .array(
                  z.object({
                    type: z
                      .enum([
                        'BY_TOTAL_WEIGHT',
                        'BY_TOTAL_PRICE',
                        'BY_TOTAL_QUANTITY',
                      ])
                      .optional(),
                    value: z
                      .string()
                      .describe(
                        'The value in respective to the condition type\nWeight values should be in the same weight units of the store: KG / LB\nTotal price is according to the store currency\nQuantity of items should be integers'
                      )
                      .optional(),
                    operator: z
                      .enum(['EQ', 'GT', 'GTE', 'LT', 'LTE'])
                      .optional(),
                  })
                )
                .min(0)
                .max(10)
                .optional(),
              multiplyByQuantity: z
                .boolean()
                .describe(
                  'When this flag is set to true, multiply the amount by the number of line items passed on the request.'
                )
                .optional(),
            })
          )
          .max(50)
          .optional(),
        _createdDate: z
          .date()
          .describe('Date and time the LocalDeliveryOption was created.')
          .optional()
          .nullable(),
        _updatedDate: z
          .date()
          .describe('Date and time the LocalDeliveryOption was last updated.')
          .optional()
          .nullable(),
        deliveryRegionIds: z.array(z.string()).max(50).optional(),
      }),
      z.xor([
        z.object({
          zipConfig: z.never().optional(),
          radiusConfig: z.never().optional(),
          customAreaConfig: z.never().optional(),
          cityConfig: z.never().optional(),
        }),
        z.object({
          radiusConfig: z.never().optional(),
          customAreaConfig: z.never().optional(),
          cityConfig: z.never().optional(),
          zipConfig: z.object({ zipCodes: z.array(z.string()).optional() }),
        }),
        z.object({
          zipConfig: z.never().optional(),
          customAreaConfig: z.never().optional(),
          cityConfig: z.never().optional(),
          radiusConfig: z.object({
            radius: z
              .number()
              .describe("Delivery circle's radius")
              .min(0.1)
              .max(50)
              .optional(),
            lengthUnit: z
              .enum(['UNSPECIFIED_LENGTH_UNIT', 'KM', 'MI'])
              .describe("Radius' unit, taken from site properties")
              .optional(),
          }),
        }),
        z.object({
          zipConfig: z.never().optional(),
          radiusConfig: z.never().optional(),
          cityConfig: z.never().optional(),
          customAreaConfig: z.object({
            geocodes: z
              .array(
                z.object({
                  latitude: z
                    .number()
                    .describe('Address latitude.')
                    .optional()
                    .nullable(),
                  longitude: z
                    .number()
                    .describe('Address longitude.')
                    .optional()
                    .nullable(),
                })
              )
              .max(300)
              .optional(),
          }),
        }),
        z.object({
          zipConfig: z.never().optional(),
          radiusConfig: z.never().optional(),
          customAreaConfig: z.never().optional(),
          cityConfig: z.object({
            cityItems: z
              .array(
                z.object({
                  cityName: z
                    .string()
                    .describe('Name of the city')
                    .min(1)
                    .max(100)
                    .optional(),
                  subdivision: z
                    .string()
                    .describe('Subdivision code of the city')
                    .optional()
                    .nullable(),
                  country: z
                    .string()
                    .describe('Country code of the city')
                    .optional(),
                  cityKey: z
                    .string()
                    .describe('Unique code of the city, calculated by Wix')
                    .max(100)
                    .optional()
                    .nullable(),
                })
              )
              .min(1)
              .max(50)
              .optional(),
          }),
        }),
      ])
    )
    .describe('LocalDeliveryOption to be updated, may be partial.'),
});
export const UpdateLocalDeliveryOptionResponse = z.intersection(
  z.object({
    _id: z
      .string()
      .describe(
        'LocalDeliveryOptionId - unique identifier of local delivery option'
      )
      .regex(
        /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
        'Must be a valid GUID'
      )
      .optional()
      .nullable(),
    areaName: z
      .string()
      .describe('Area name of Local Delivery Option')
      .max(100)
      .optional()
      .nullable(),
    rate: z
      .string()
      .describe('Flat price of local delivery')
      .optional()
      .nullable(),
    estimatedDeliveryTime: z
      .string()
      .describe('Estimated delivery time description text')
      .max(40)
      .optional()
      .nullable(),
    minimumFreeDeliveryOrderAmount: z
      .number()
      .describe('Minimum order total to be eligible for free delivery')
      .optional()
      .nullable(),
    destinations: z
      .array(
        z.object({
          code: z.string().describe('Country ISO code').optional(),
          subdivisions: z.array(z.string()).max(200).optional(),
        })
      )
      .min(0)
      .max(100)
      .optional(),
    revision: z
      .string()
      .regex(/^\d+$/, 'Must be a valid UInt64 string')
      .describe(
        'Database revision of LocalDeliveryOption entity. Incremented on each modification'
      )
      .optional()
      .nullable(),
    scheduledDeliveryConfig: z
      .object({
        days: z
          .object({
            monday: z
              .object({
                enabledForDelivery: z
                  .boolean()
                  .describe(
                    'Shows whether this day slot is enabled for delivery'
                  )
                  .optional()
                  .nullable(),
                timeSlots: z
                  .array(
                    z.object({
                      from: z
                        .object({
                          hours: z
                            .number()
                            .int()
                            .describe('Hours in format 0-23')
                            .min(0)
                            .max(23)
                            .optional()
                            .nullable(),
                          minutes: z
                            .number()
                            .int()
                            .describe('Minutes 0-59')
                            .min(0)
                            .max(59)
                            .optional()
                            .nullable(),
                        })
                        .describe('Starting time point of time slot')
                        .optional(),
                      to: z
                        .object({
                          hours: z
                            .number()
                            .int()
                            .describe('Hours in format 0-23')
                            .min(0)
                            .max(23)
                            .optional()
                            .nullable(),
                          minutes: z
                            .number()
                            .int()
                            .describe('Minutes 0-59')
                            .min(0)
                            .max(59)
                            .optional()
                            .nullable(),
                        })
                        .describe('End time point of time slot')
                        .optional(),
                    })
                  )
                  .min(0)
                  .max(8)
                  .optional(),
              })
              .optional(),
            tuesday: z
              .object({
                enabledForDelivery: z
                  .boolean()
                  .describe(
                    'Shows whether this day slot is enabled for delivery'
                  )
                  .optional()
                  .nullable(),
                timeSlots: z
                  .array(
                    z.object({
                      from: z
                        .object({
                          hours: z
                            .number()
                            .int()
                            .describe('Hours in format 0-23')
                            .min(0)
                            .max(23)
                            .optional()
                            .nullable(),
                          minutes: z
                            .number()
                            .int()
                            .describe('Minutes 0-59')
                            .min(0)
                            .max(59)
                            .optional()
                            .nullable(),
                        })
                        .describe('Starting time point of time slot')
                        .optional(),
                      to: z
                        .object({
                          hours: z
                            .number()
                            .int()
                            .describe('Hours in format 0-23')
                            .min(0)
                            .max(23)
                            .optional()
                            .nullable(),
                          minutes: z
                            .number()
                            .int()
                            .describe('Minutes 0-59')
                            .min(0)
                            .max(59)
                            .optional()
                            .nullable(),
                        })
                        .describe('End time point of time slot')
                        .optional(),
                    })
                  )
                  .min(0)
                  .max(8)
                  .optional(),
              })
              .optional(),
            wednesday: z
              .object({
                enabledForDelivery: z
                  .boolean()
                  .describe(
                    'Shows whether this day slot is enabled for delivery'
                  )
                  .optional()
                  .nullable(),
                timeSlots: z
                  .array(
                    z.object({
                      from: z
                        .object({
                          hours: z
                            .number()
                            .int()
                            .describe('Hours in format 0-23')
                            .min(0)
                            .max(23)
                            .optional()
                            .nullable(),
                          minutes: z
                            .number()
                            .int()
                            .describe('Minutes 0-59')
                            .min(0)
                            .max(59)
                            .optional()
                            .nullable(),
                        })
                        .describe('Starting time point of time slot')
                        .optional(),
                      to: z
                        .object({
                          hours: z
                            .number()
                            .int()
                            .describe('Hours in format 0-23')
                            .min(0)
                            .max(23)
                            .optional()
                            .nullable(),
                          minutes: z
                            .number()
                            .int()
                            .describe('Minutes 0-59')
                            .min(0)
                            .max(59)
                            .optional()
                            .nullable(),
                        })
                        .describe('End time point of time slot')
                        .optional(),
                    })
                  )
                  .min(0)
                  .max(8)
                  .optional(),
              })
              .optional(),
            thursday: z
              .object({
                enabledForDelivery: z
                  .boolean()
                  .describe(
                    'Shows whether this day slot is enabled for delivery'
                  )
                  .optional()
                  .nullable(),
                timeSlots: z
                  .array(
                    z.object({
                      from: z
                        .object({
                          hours: z
                            .number()
                            .int()
                            .describe('Hours in format 0-23')
                            .min(0)
                            .max(23)
                            .optional()
                            .nullable(),
                          minutes: z
                            .number()
                            .int()
                            .describe('Minutes 0-59')
                            .min(0)
                            .max(59)
                            .optional()
                            .nullable(),
                        })
                        .describe('Starting time point of time slot')
                        .optional(),
                      to: z
                        .object({
                          hours: z
                            .number()
                            .int()
                            .describe('Hours in format 0-23')
                            .min(0)
                            .max(23)
                            .optional()
                            .nullable(),
                          minutes: z
                            .number()
                            .int()
                            .describe('Minutes 0-59')
                            .min(0)
                            .max(59)
                            .optional()
                            .nullable(),
                        })
                        .describe('End time point of time slot')
                        .optional(),
                    })
                  )
                  .min(0)
                  .max(8)
                  .optional(),
              })
              .optional(),
            friday: z
              .object({
                enabledForDelivery: z
                  .boolean()
                  .describe(
                    'Shows whether this day slot is enabled for delivery'
                  )
                  .optional()
                  .nullable(),
                timeSlots: z
                  .array(
                    z.object({
                      from: z
                        .object({
                          hours: z
                            .number()
                            .int()
                            .describe('Hours in format 0-23')
                            .min(0)
                            .max(23)
                            .optional()
                            .nullable(),
                          minutes: z
                            .number()
                            .int()
                            .describe('Minutes 0-59')
                            .min(0)
                            .max(59)
                            .optional()
                            .nullable(),
                        })
                        .describe('Starting time point of time slot')
                        .optional(),
                      to: z
                        .object({
                          hours: z
                            .number()
                            .int()
                            .describe('Hours in format 0-23')
                            .min(0)
                            .max(23)
                            .optional()
                            .nullable(),
                          minutes: z
                            .number()
                            .int()
                            .describe('Minutes 0-59')
                            .min(0)
                            .max(59)
                            .optional()
                            .nullable(),
                        })
                        .describe('End time point of time slot')
                        .optional(),
                    })
                  )
                  .min(0)
                  .max(8)
                  .optional(),
              })
              .optional(),
            saturday: z
              .object({
                enabledForDelivery: z
                  .boolean()
                  .describe(
                    'Shows whether this day slot is enabled for delivery'
                  )
                  .optional()
                  .nullable(),
                timeSlots: z
                  .array(
                    z.object({
                      from: z
                        .object({
                          hours: z
                            .number()
                            .int()
                            .describe('Hours in format 0-23')
                            .min(0)
                            .max(23)
                            .optional()
                            .nullable(),
                          minutes: z
                            .number()
                            .int()
                            .describe('Minutes 0-59')
                            .min(0)
                            .max(59)
                            .optional()
                            .nullable(),
                        })
                        .describe('Starting time point of time slot')
                        .optional(),
                      to: z
                        .object({
                          hours: z
                            .number()
                            .int()
                            .describe('Hours in format 0-23')
                            .min(0)
                            .max(23)
                            .optional()
                            .nullable(),
                          minutes: z
                            .number()
                            .int()
                            .describe('Minutes 0-59')
                            .min(0)
                            .max(59)
                            .optional()
                            .nullable(),
                        })
                        .describe('End time point of time slot')
                        .optional(),
                    })
                  )
                  .min(0)
                  .max(8)
                  .optional(),
              })
              .optional(),
            sunday: z
              .object({
                enabledForDelivery: z
                  .boolean()
                  .describe(
                    'Shows whether this day slot is enabled for delivery'
                  )
                  .optional()
                  .nullable(),
                timeSlots: z
                  .array(
                    z.object({
                      from: z
                        .object({
                          hours: z
                            .number()
                            .int()
                            .describe('Hours in format 0-23')
                            .min(0)
                            .max(23)
                            .optional()
                            .nullable(),
                          minutes: z
                            .number()
                            .int()
                            .describe('Minutes 0-59')
                            .min(0)
                            .max(59)
                            .optional()
                            .nullable(),
                        })
                        .describe('Starting time point of time slot')
                        .optional(),
                      to: z
                        .object({
                          hours: z
                            .number()
                            .int()
                            .describe('Hours in format 0-23')
                            .min(0)
                            .max(23)
                            .optional()
                            .nullable(),
                          minutes: z
                            .number()
                            .int()
                            .describe('Minutes 0-59')
                            .min(0)
                            .max(59)
                            .optional()
                            .nullable(),
                        })
                        .describe('End time point of time slot')
                        .optional(),
                    })
                  )
                  .min(0)
                  .max(8)
                  .optional(),
              })
              .optional(),
          })
          .describe(
            "Days config which contain days when delivery is enabled with it's time slots"
          )
          .optional(),
        handlingDays: z
          .number()
          .int()
          .describe('Amount of days before first delivery option date')
          .min(0)
          .max(30)
          .optional()
          .nullable(),
        cutOffTime: z
          .object({
            hours: z
              .number()
              .int()
              .describe('Hours in format 0-23')
              .min(0)
              .max(23)
              .optional()
              .nullable(),
            minutes: z
              .number()
              .int()
              .describe('Minutes 0-59')
              .min(0)
              .max(59)
              .optional()
              .nullable(),
          })
          .describe(
            'Cut off time after which first delivery option would be for next day'
          )
          .optional(),
        timeWindows: z
          .array(
            z.object({
              day: z
                .enum(['MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT', 'SUN'])
                .describe('The day of week this availability relates to.')
                .optional(),
              start: z
                .object({
                  hours: z
                    .number()
                    .int()
                    .describe('Hours')
                    .min(0)
                    .max(23)
                    .optional(),
                  minutes: z
                    .number()
                    .int()
                    .describe('Minutes')
                    .min(0)
                    .max(59)
                    .optional(),
                })
                .describe('The start time in time of day representation.')
                .optional(),
              end: z
                .object({
                  hours: z
                    .number()
                    .int()
                    .describe('Hours')
                    .min(0)
                    .max(23)
                    .optional(),
                  minutes: z
                    .number()
                    .int()
                    .describe('Minutes')
                    .min(0)
                    .max(59)
                    .optional(),
                })
                .describe('The end time in time of day representation.')
                .optional(),
              enabled: z
                .boolean()
                .describe('Whether this timeWindow availability is enabled.')
                .optional()
                .nullable(),
            })
          )
          .min(0)
          .max(100)
          .optional(),
      })
      .optional(),
    rates: z
      .array(
        z.object({
          amount: z
            .string()
            .describe(
              'there is an AND logic between all the conditions. Empty conditions means true.\nThe amount of the rate that will be returned if all conditions are met.'
            )
            .optional(),
          conditions: z
            .array(
              z.object({
                type: z
                  .enum([
                    'BY_TOTAL_WEIGHT',
                    'BY_TOTAL_PRICE',
                    'BY_TOTAL_QUANTITY',
                  ])
                  .optional(),
                value: z
                  .string()
                  .describe(
                    'The value in respective to the condition type\nWeight values should be in the same weight units of the store: KG / LB\nTotal price is according to the store currency\nQuantity of items should be integers'
                  )
                  .optional(),
                operator: z
                  .enum(['EQ', 'GT', 'GTE', 'LT', 'LTE'])
                  .describe('Logical operator.')
                  .optional(),
              })
            )
            .min(0)
            .max(10)
            .optional(),
          multiplyByQuantity: z
            .boolean()
            .describe(
              'When this flag is set to true, multiply the amount by the number of line items passed on the request.'
            )
            .optional(),
        })
      )
      .max(50)
      .optional(),
    _createdDate: z
      .date()
      .describe('Date and time the LocalDeliveryOption was created.')
      .optional()
      .nullable(),
    _updatedDate: z
      .date()
      .describe('Date and time the LocalDeliveryOption was last updated.')
      .optional()
      .nullable(),
    deliveryRegionIds: z.array(z.string()).max(50).optional(),
  }),
  z.xor([
    z.object({
      zipConfig: z.never().optional(),
      radiusConfig: z.never().optional(),
      customAreaConfig: z.never().optional(),
      cityConfig: z.never().optional(),
    }),
    z.object({
      radiusConfig: z.never().optional(),
      customAreaConfig: z.never().optional(),
      cityConfig: z.never().optional(),
      zipConfig: z.object({ zipCodes: z.array(z.string()).optional() }),
    }),
    z.object({
      zipConfig: z.never().optional(),
      customAreaConfig: z.never().optional(),
      cityConfig: z.never().optional(),
      radiusConfig: z.object({
        radius: z
          .number()
          .describe("Delivery circle's radius")
          .min(0.1)
          .max(50)
          .optional(),
        lengthUnit: z
          .enum(['UNSPECIFIED_LENGTH_UNIT', 'KM', 'MI'])
          .describe("Radius' unit, taken from site properties")
          .optional(),
      }),
    }),
    z.object({
      zipConfig: z.never().optional(),
      radiusConfig: z.never().optional(),
      cityConfig: z.never().optional(),
      customAreaConfig: z.object({
        geocodes: z
          .array(
            z.object({
              latitude: z
                .number()
                .describe('Address latitude.')
                .optional()
                .nullable(),
              longitude: z
                .number()
                .describe('Address longitude.')
                .optional()
                .nullable(),
            })
          )
          .max(300)
          .optional(),
      }),
    }),
    z.object({
      zipConfig: z.never().optional(),
      radiusConfig: z.never().optional(),
      customAreaConfig: z.never().optional(),
      cityConfig: z.object({
        cityItems: z
          .array(
            z.object({
              cityName: z
                .string()
                .describe('Name of the city')
                .min(1)
                .max(100)
                .optional(),
              subdivision: z
                .string()
                .describe('Subdivision code of the city')
                .optional()
                .nullable(),
              country: z
                .string()
                .describe('Country code of the city')
                .optional(),
              cityKey: z
                .string()
                .describe('Unique code of the city, calculated by Wix')
                .max(100)
                .optional()
                .nullable(),
            })
          )
          .min(1)
          .max(50)
          .optional(),
      }),
    }),
  ])
);
export const DeleteLocalDeliveryOptionRequest = z.object({
  localDeliveryOptionId: z.string().max(50),
  options: z.object({ id: z.string().max(50).optional() }).optional(),
});
export const DeleteLocalDeliveryOptionResponse = z.object({});
export const BulkCreateLocalDeliveryOptionRequest = z.object({
  localDeliveryOptions: z
    .array(
      z.intersection(
        z.object({
          _id: z
            .string()
            .describe(
              'LocalDeliveryOptionId - unique identifier of local delivery option'
            )
            .regex(
              /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
              'Must be a valid GUID'
            )
            .optional()
            .nullable(),
          areaName: z
            .string()
            .describe('Area name of Local Delivery Option')
            .max(100)
            .optional()
            .nullable(),
          rate: z
            .string()
            .describe('Flat price of local delivery')
            .optional()
            .nullable(),
          estimatedDeliveryTime: z
            .string()
            .describe('Estimated delivery time description text')
            .max(40)
            .optional()
            .nullable(),
          minimumFreeDeliveryOrderAmount: z
            .number()
            .describe('Minimum order total to be eligible for free delivery')
            .optional()
            .nullable(),
          destinations: z
            .array(
              z.object({
                code: z.string().describe('Country ISO code').optional(),
                subdivisions: z.array(z.string()).max(200).optional(),
              })
            )
            .min(0)
            .max(100)
            .optional(),
          revision: z
            .string()
            .regex(/^\d+$/, 'Must be a valid UInt64 string')
            .describe(
              'Database revision of LocalDeliveryOption entity. Incremented on each modification'
            )
            .optional()
            .nullable(),
          scheduledDeliveryConfig: z
            .object({
              days: z
                .object({
                  monday: z.object({
                    enabledForDelivery: z
                      .boolean()
                      .describe(
                        'Shows whether this day slot is enabled for delivery'
                      ),
                    timeSlots: z
                      .array(
                        z.object({
                          from: z
                            .object({
                              hours: z
                                .number()
                                .int()
                                .describe('Hours in format 0-23')
                                .min(0)
                                .max(23),
                              minutes: z
                                .number()
                                .int()
                                .describe('Minutes 0-59')
                                .min(0)
                                .max(59),
                            })
                            .describe('Starting time point of time slot'),
                          to: z
                            .object({
                              hours: z
                                .number()
                                .int()
                                .describe('Hours in format 0-23')
                                .min(0)
                                .max(23),
                              minutes: z
                                .number()
                                .int()
                                .describe('Minutes 0-59')
                                .min(0)
                                .max(59),
                            })
                            .describe('End time point of time slot'),
                        })
                      )
                      .min(0)
                      .max(8)
                      .optional(),
                  }),
                  tuesday: z.object({
                    enabledForDelivery: z
                      .boolean()
                      .describe(
                        'Shows whether this day slot is enabled for delivery'
                      ),
                    timeSlots: z
                      .array(
                        z.object({
                          from: z
                            .object({
                              hours: z
                                .number()
                                .int()
                                .describe('Hours in format 0-23')
                                .min(0)
                                .max(23),
                              minutes: z
                                .number()
                                .int()
                                .describe('Minutes 0-59')
                                .min(0)
                                .max(59),
                            })
                            .describe('Starting time point of time slot'),
                          to: z
                            .object({
                              hours: z
                                .number()
                                .int()
                                .describe('Hours in format 0-23')
                                .min(0)
                                .max(23),
                              minutes: z
                                .number()
                                .int()
                                .describe('Minutes 0-59')
                                .min(0)
                                .max(59),
                            })
                            .describe('End time point of time slot'),
                        })
                      )
                      .min(0)
                      .max(8)
                      .optional(),
                  }),
                  wednesday: z.object({
                    enabledForDelivery: z
                      .boolean()
                      .describe(
                        'Shows whether this day slot is enabled for delivery'
                      ),
                    timeSlots: z
                      .array(
                        z.object({
                          from: z
                            .object({
                              hours: z
                                .number()
                                .int()
                                .describe('Hours in format 0-23')
                                .min(0)
                                .max(23),
                              minutes: z
                                .number()
                                .int()
                                .describe('Minutes 0-59')
                                .min(0)
                                .max(59),
                            })
                            .describe('Starting time point of time slot'),
                          to: z
                            .object({
                              hours: z
                                .number()
                                .int()
                                .describe('Hours in format 0-23')
                                .min(0)
                                .max(23),
                              minutes: z
                                .number()
                                .int()
                                .describe('Minutes 0-59')
                                .min(0)
                                .max(59),
                            })
                            .describe('End time point of time slot'),
                        })
                      )
                      .min(0)
                      .max(8)
                      .optional(),
                  }),
                  thursday: z.object({
                    enabledForDelivery: z
                      .boolean()
                      .describe(
                        'Shows whether this day slot is enabled for delivery'
                      ),
                    timeSlots: z
                      .array(
                        z.object({
                          from: z
                            .object({
                              hours: z
                                .number()
                                .int()
                                .describe('Hours in format 0-23')
                                .min(0)
                                .max(23),
                              minutes: z
                                .number()
                                .int()
                                .describe('Minutes 0-59')
                                .min(0)
                                .max(59),
                            })
                            .describe('Starting time point of time slot'),
                          to: z
                            .object({
                              hours: z
                                .number()
                                .int()
                                .describe('Hours in format 0-23')
                                .min(0)
                                .max(23),
                              minutes: z
                                .number()
                                .int()
                                .describe('Minutes 0-59')
                                .min(0)
                                .max(59),
                            })
                            .describe('End time point of time slot'),
                        })
                      )
                      .min(0)
                      .max(8)
                      .optional(),
                  }),
                  friday: z.object({
                    enabledForDelivery: z
                      .boolean()
                      .describe(
                        'Shows whether this day slot is enabled for delivery'
                      ),
                    timeSlots: z
                      .array(
                        z.object({
                          from: z
                            .object({
                              hours: z
                                .number()
                                .int()
                                .describe('Hours in format 0-23')
                                .min(0)
                                .max(23),
                              minutes: z
                                .number()
                                .int()
                                .describe('Minutes 0-59')
                                .min(0)
                                .max(59),
                            })
                            .describe('Starting time point of time slot'),
                          to: z
                            .object({
                              hours: z
                                .number()
                                .int()
                                .describe('Hours in format 0-23')
                                .min(0)
                                .max(23),
                              minutes: z
                                .number()
                                .int()
                                .describe('Minutes 0-59')
                                .min(0)
                                .max(59),
                            })
                            .describe('End time point of time slot'),
                        })
                      )
                      .min(0)
                      .max(8)
                      .optional(),
                  }),
                  saturday: z.object({
                    enabledForDelivery: z
                      .boolean()
                      .describe(
                        'Shows whether this day slot is enabled for delivery'
                      ),
                    timeSlots: z
                      .array(
                        z.object({
                          from: z
                            .object({
                              hours: z
                                .number()
                                .int()
                                .describe('Hours in format 0-23')
                                .min(0)
                                .max(23),
                              minutes: z
                                .number()
                                .int()
                                .describe('Minutes 0-59')
                                .min(0)
                                .max(59),
                            })
                            .describe('Starting time point of time slot'),
                          to: z
                            .object({
                              hours: z
                                .number()
                                .int()
                                .describe('Hours in format 0-23')
                                .min(0)
                                .max(23),
                              minutes: z
                                .number()
                                .int()
                                .describe('Minutes 0-59')
                                .min(0)
                                .max(59),
                            })
                            .describe('End time point of time slot'),
                        })
                      )
                      .min(0)
                      .max(8)
                      .optional(),
                  }),
                  sunday: z.object({
                    enabledForDelivery: z
                      .boolean()
                      .describe(
                        'Shows whether this day slot is enabled for delivery'
                      ),
                    timeSlots: z
                      .array(
                        z.object({
                          from: z
                            .object({
                              hours: z
                                .number()
                                .int()
                                .describe('Hours in format 0-23')
                                .min(0)
                                .max(23),
                              minutes: z
                                .number()
                                .int()
                                .describe('Minutes 0-59')
                                .min(0)
                                .max(59),
                            })
                            .describe('Starting time point of time slot'),
                          to: z
                            .object({
                              hours: z
                                .number()
                                .int()
                                .describe('Hours in format 0-23')
                                .min(0)
                                .max(23),
                              minutes: z
                                .number()
                                .int()
                                .describe('Minutes 0-59')
                                .min(0)
                                .max(59),
                            })
                            .describe('End time point of time slot'),
                        })
                      )
                      .min(0)
                      .max(8)
                      .optional(),
                  }),
                })
                .describe(
                  "Days config which contain days when delivery is enabled with it's time slots"
                )
                .optional(),
              handlingDays: z
                .number()
                .int()
                .describe('Amount of days before first delivery option date')
                .min(0)
                .max(30),
              cutOffTime: z
                .object({
                  hours: z
                    .number()
                    .int()
                    .describe('Hours in format 0-23')
                    .min(0)
                    .max(23),
                  minutes: z
                    .number()
                    .int()
                    .describe('Minutes 0-59')
                    .min(0)
                    .max(59),
                })
                .describe(
                  'Cut off time after which first delivery option would be for next day'
                )
                .optional(),
              timeWindows: z
                .array(
                  z.object({
                    day: z
                      .enum(['MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT', 'SUN'])
                      .optional(),
                    start: z
                      .object({
                        hours: z
                          .number()
                          .int()
                          .describe('Hours')
                          .min(0)
                          .max(23)
                          .optional(),
                        minutes: z
                          .number()
                          .int()
                          .describe('Minutes')
                          .min(0)
                          .max(59)
                          .optional(),
                      })
                      .describe('The start time in time of day representation.')
                      .optional(),
                    end: z
                      .object({
                        hours: z
                          .number()
                          .int()
                          .describe('Hours')
                          .min(0)
                          .max(23)
                          .optional(),
                        minutes: z
                          .number()
                          .int()
                          .describe('Minutes')
                          .min(0)
                          .max(59)
                          .optional(),
                      })
                      .describe('The end time in time of day representation.')
                      .optional(),
                    enabled: z
                      .boolean()
                      .describe(
                        'Whether this timeWindow availability is enabled.'
                      )
                      .optional()
                      .nullable(),
                  })
                )
                .min(0)
                .max(100)
                .optional(),
            })
            .optional(),
          rates: z
            .array(
              z.object({
                amount: z
                  .string()
                  .describe(
                    'there is an AND logic between all the conditions. Empty conditions means true.\nThe amount of the rate that will be returned if all conditions are met.'
                  )
                  .optional(),
                conditions: z
                  .array(
                    z.object({
                      type: z
                        .enum([
                          'BY_TOTAL_WEIGHT',
                          'BY_TOTAL_PRICE',
                          'BY_TOTAL_QUANTITY',
                        ])
                        .optional(),
                      value: z
                        .string()
                        .describe(
                          'The value in respective to the condition type\nWeight values should be in the same weight units of the store: KG / LB\nTotal price is according to the store currency\nQuantity of items should be integers'
                        )
                        .optional(),
                      operator: z
                        .enum(['EQ', 'GT', 'GTE', 'LT', 'LTE'])
                        .optional(),
                    })
                  )
                  .min(0)
                  .max(10)
                  .optional(),
                multiplyByQuantity: z
                  .boolean()
                  .describe(
                    'When this flag is set to true, multiply the amount by the number of line items passed on the request.'
                  )
                  .optional(),
              })
            )
            .max(50)
            .optional(),
          _createdDate: z
            .date()
            .describe('Date and time the LocalDeliveryOption was created.')
            .optional()
            .nullable(),
          _updatedDate: z
            .date()
            .describe('Date and time the LocalDeliveryOption was last updated.')
            .optional()
            .nullable(),
          deliveryRegionIds: z.array(z.string()).max(50).optional(),
        }),
        z.xor([
          z.object({
            zipConfig: z.never().optional(),
            radiusConfig: z.never().optional(),
            customAreaConfig: z.never().optional(),
            cityConfig: z.never().optional(),
          }),
          z.object({
            radiusConfig: z.never().optional(),
            customAreaConfig: z.never().optional(),
            cityConfig: z.never().optional(),
            zipConfig: z.object({ zipCodes: z.array(z.string()).optional() }),
          }),
          z.object({
            zipConfig: z.never().optional(),
            customAreaConfig: z.never().optional(),
            cityConfig: z.never().optional(),
            radiusConfig: z.object({
              radius: z
                .number()
                .describe("Delivery circle's radius")
                .min(0.1)
                .max(50)
                .optional(),
              lengthUnit: z
                .enum(['UNSPECIFIED_LENGTH_UNIT', 'KM', 'MI'])
                .describe("Radius' unit, taken from site properties")
                .optional(),
            }),
          }),
          z.object({
            zipConfig: z.never().optional(),
            radiusConfig: z.never().optional(),
            cityConfig: z.never().optional(),
            customAreaConfig: z.object({
              geocodes: z
                .array(
                  z.object({
                    latitude: z
                      .number()
                      .describe('Address latitude.')
                      .optional()
                      .nullable(),
                    longitude: z
                      .number()
                      .describe('Address longitude.')
                      .optional()
                      .nullable(),
                  })
                )
                .max(300)
                .optional(),
            }),
          }),
          z.object({
            zipConfig: z.never().optional(),
            radiusConfig: z.never().optional(),
            customAreaConfig: z.never().optional(),
            cityConfig: z.object({
              cityItems: z
                .array(
                  z.object({
                    cityName: z
                      .string()
                      .describe('Name of the city')
                      .min(1)
                      .max(100)
                      .optional(),
                    subdivision: z
                      .string()
                      .describe('Subdivision code of the city')
                      .optional()
                      .nullable(),
                    country: z
                      .string()
                      .describe('Country code of the city')
                      .optional(),
                    cityKey: z
                      .string()
                      .describe('Unique code of the city, calculated by Wix')
                      .max(100)
                      .optional()
                      .nullable(),
                  })
                )
                .min(1)
                .max(50)
                .optional(),
            }),
          }),
        ])
      )
    )
    .min(1)
    .max(100),
});
export const BulkCreateLocalDeliveryOptionResponse = z.object({
  localDeliveryOptions: z
    .array(
      z.intersection(
        z.object({
          _id: z
            .string()
            .describe(
              'LocalDeliveryOptionId - unique identifier of local delivery option'
            )
            .regex(
              /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
              'Must be a valid GUID'
            )
            .optional()
            .nullable(),
          areaName: z
            .string()
            .describe('Area name of Local Delivery Option')
            .max(100)
            .optional()
            .nullable(),
          rate: z
            .string()
            .describe('Flat price of local delivery')
            .optional()
            .nullable(),
          estimatedDeliveryTime: z
            .string()
            .describe('Estimated delivery time description text')
            .max(40)
            .optional()
            .nullable(),
          minimumFreeDeliveryOrderAmount: z
            .number()
            .describe('Minimum order total to be eligible for free delivery')
            .optional()
            .nullable(),
          destinations: z
            .array(
              z.object({
                code: z.string().describe('Country ISO code').optional(),
                subdivisions: z.array(z.string()).max(200).optional(),
              })
            )
            .min(0)
            .max(100)
            .optional(),
          revision: z
            .string()
            .regex(/^\d+$/, 'Must be a valid UInt64 string')
            .describe(
              'Database revision of LocalDeliveryOption entity. Incremented on each modification'
            )
            .optional()
            .nullable(),
          scheduledDeliveryConfig: z
            .object({
              days: z
                .object({
                  monday: z
                    .object({
                      enabledForDelivery: z
                        .boolean()
                        .describe(
                          'Shows whether this day slot is enabled for delivery'
                        )
                        .optional()
                        .nullable(),
                      timeSlots: z
                        .array(
                          z.object({
                            from: z
                              .object({
                                hours: z
                                  .number()
                                  .int()
                                  .describe('Hours in format 0-23')
                                  .min(0)
                                  .max(23)
                                  .optional()
                                  .nullable(),
                                minutes: z
                                  .number()
                                  .int()
                                  .describe('Minutes 0-59')
                                  .min(0)
                                  .max(59)
                                  .optional()
                                  .nullable(),
                              })
                              .describe('Starting time point of time slot')
                              .optional(),
                            to: z
                              .object({
                                hours: z
                                  .number()
                                  .int()
                                  .describe('Hours in format 0-23')
                                  .min(0)
                                  .max(23)
                                  .optional()
                                  .nullable(),
                                minutes: z
                                  .number()
                                  .int()
                                  .describe('Minutes 0-59')
                                  .min(0)
                                  .max(59)
                                  .optional()
                                  .nullable(),
                              })
                              .describe('End time point of time slot')
                              .optional(),
                          })
                        )
                        .min(0)
                        .max(8)
                        .optional(),
                    })
                    .optional(),
                  tuesday: z
                    .object({
                      enabledForDelivery: z
                        .boolean()
                        .describe(
                          'Shows whether this day slot is enabled for delivery'
                        )
                        .optional()
                        .nullable(),
                      timeSlots: z
                        .array(
                          z.object({
                            from: z
                              .object({
                                hours: z
                                  .number()
                                  .int()
                                  .describe('Hours in format 0-23')
                                  .min(0)
                                  .max(23)
                                  .optional()
                                  .nullable(),
                                minutes: z
                                  .number()
                                  .int()
                                  .describe('Minutes 0-59')
                                  .min(0)
                                  .max(59)
                                  .optional()
                                  .nullable(),
                              })
                              .describe('Starting time point of time slot')
                              .optional(),
                            to: z
                              .object({
                                hours: z
                                  .number()
                                  .int()
                                  .describe('Hours in format 0-23')
                                  .min(0)
                                  .max(23)
                                  .optional()
                                  .nullable(),
                                minutes: z
                                  .number()
                                  .int()
                                  .describe('Minutes 0-59')
                                  .min(0)
                                  .max(59)
                                  .optional()
                                  .nullable(),
                              })
                              .describe('End time point of time slot')
                              .optional(),
                          })
                        )
                        .min(0)
                        .max(8)
                        .optional(),
                    })
                    .optional(),
                  wednesday: z
                    .object({
                      enabledForDelivery: z
                        .boolean()
                        .describe(
                          'Shows whether this day slot is enabled for delivery'
                        )
                        .optional()
                        .nullable(),
                      timeSlots: z
                        .array(
                          z.object({
                            from: z
                              .object({
                                hours: z
                                  .number()
                                  .int()
                                  .describe('Hours in format 0-23')
                                  .min(0)
                                  .max(23)
                                  .optional()
                                  .nullable(),
                                minutes: z
                                  .number()
                                  .int()
                                  .describe('Minutes 0-59')
                                  .min(0)
                                  .max(59)
                                  .optional()
                                  .nullable(),
                              })
                              .describe('Starting time point of time slot')
                              .optional(),
                            to: z
                              .object({
                                hours: z
                                  .number()
                                  .int()
                                  .describe('Hours in format 0-23')
                                  .min(0)
                                  .max(23)
                                  .optional()
                                  .nullable(),
                                minutes: z
                                  .number()
                                  .int()
                                  .describe('Minutes 0-59')
                                  .min(0)
                                  .max(59)
                                  .optional()
                                  .nullable(),
                              })
                              .describe('End time point of time slot')
                              .optional(),
                          })
                        )
                        .min(0)
                        .max(8)
                        .optional(),
                    })
                    .optional(),
                  thursday: z
                    .object({
                      enabledForDelivery: z
                        .boolean()
                        .describe(
                          'Shows whether this day slot is enabled for delivery'
                        )
                        .optional()
                        .nullable(),
                      timeSlots: z
                        .array(
                          z.object({
                            from: z
                              .object({
                                hours: z
                                  .number()
                                  .int()
                                  .describe('Hours in format 0-23')
                                  .min(0)
                                  .max(23)
                                  .optional()
                                  .nullable(),
                                minutes: z
                                  .number()
                                  .int()
                                  .describe('Minutes 0-59')
                                  .min(0)
                                  .max(59)
                                  .optional()
                                  .nullable(),
                              })
                              .describe('Starting time point of time slot')
                              .optional(),
                            to: z
                              .object({
                                hours: z
                                  .number()
                                  .int()
                                  .describe('Hours in format 0-23')
                                  .min(0)
                                  .max(23)
                                  .optional()
                                  .nullable(),
                                minutes: z
                                  .number()
                                  .int()
                                  .describe('Minutes 0-59')
                                  .min(0)
                                  .max(59)
                                  .optional()
                                  .nullable(),
                              })
                              .describe('End time point of time slot')
                              .optional(),
                          })
                        )
                        .min(0)
                        .max(8)
                        .optional(),
                    })
                    .optional(),
                  friday: z
                    .object({
                      enabledForDelivery: z
                        .boolean()
                        .describe(
                          'Shows whether this day slot is enabled for delivery'
                        )
                        .optional()
                        .nullable(),
                      timeSlots: z
                        .array(
                          z.object({
                            from: z
                              .object({
                                hours: z
                                  .number()
                                  .int()
                                  .describe('Hours in format 0-23')
                                  .min(0)
                                  .max(23)
                                  .optional()
                                  .nullable(),
                                minutes: z
                                  .number()
                                  .int()
                                  .describe('Minutes 0-59')
                                  .min(0)
                                  .max(59)
                                  .optional()
                                  .nullable(),
                              })
                              .describe('Starting time point of time slot')
                              .optional(),
                            to: z
                              .object({
                                hours: z
                                  .number()
                                  .int()
                                  .describe('Hours in format 0-23')
                                  .min(0)
                                  .max(23)
                                  .optional()
                                  .nullable(),
                                minutes: z
                                  .number()
                                  .int()
                                  .describe('Minutes 0-59')
                                  .min(0)
                                  .max(59)
                                  .optional()
                                  .nullable(),
                              })
                              .describe('End time point of time slot')
                              .optional(),
                          })
                        )
                        .min(0)
                        .max(8)
                        .optional(),
                    })
                    .optional(),
                  saturday: z
                    .object({
                      enabledForDelivery: z
                        .boolean()
                        .describe(
                          'Shows whether this day slot is enabled for delivery'
                        )
                        .optional()
                        .nullable(),
                      timeSlots: z
                        .array(
                          z.object({
                            from: z
                              .object({
                                hours: z
                                  .number()
                                  .int()
                                  .describe('Hours in format 0-23')
                                  .min(0)
                                  .max(23)
                                  .optional()
                                  .nullable(),
                                minutes: z
                                  .number()
                                  .int()
                                  .describe('Minutes 0-59')
                                  .min(0)
                                  .max(59)
                                  .optional()
                                  .nullable(),
                              })
                              .describe('Starting time point of time slot')
                              .optional(),
                            to: z
                              .object({
                                hours: z
                                  .number()
                                  .int()
                                  .describe('Hours in format 0-23')
                                  .min(0)
                                  .max(23)
                                  .optional()
                                  .nullable(),
                                minutes: z
                                  .number()
                                  .int()
                                  .describe('Minutes 0-59')
                                  .min(0)
                                  .max(59)
                                  .optional()
                                  .nullable(),
                              })
                              .describe('End time point of time slot')
                              .optional(),
                          })
                        )
                        .min(0)
                        .max(8)
                        .optional(),
                    })
                    .optional(),
                  sunday: z
                    .object({
                      enabledForDelivery: z
                        .boolean()
                        .describe(
                          'Shows whether this day slot is enabled for delivery'
                        )
                        .optional()
                        .nullable(),
                      timeSlots: z
                        .array(
                          z.object({
                            from: z
                              .object({
                                hours: z
                                  .number()
                                  .int()
                                  .describe('Hours in format 0-23')
                                  .min(0)
                                  .max(23)
                                  .optional()
                                  .nullable(),
                                minutes: z
                                  .number()
                                  .int()
                                  .describe('Minutes 0-59')
                                  .min(0)
                                  .max(59)
                                  .optional()
                                  .nullable(),
                              })
                              .describe('Starting time point of time slot')
                              .optional(),
                            to: z
                              .object({
                                hours: z
                                  .number()
                                  .int()
                                  .describe('Hours in format 0-23')
                                  .min(0)
                                  .max(23)
                                  .optional()
                                  .nullable(),
                                minutes: z
                                  .number()
                                  .int()
                                  .describe('Minutes 0-59')
                                  .min(0)
                                  .max(59)
                                  .optional()
                                  .nullable(),
                              })
                              .describe('End time point of time slot')
                              .optional(),
                          })
                        )
                        .min(0)
                        .max(8)
                        .optional(),
                    })
                    .optional(),
                })
                .describe(
                  "Days config which contain days when delivery is enabled with it's time slots"
                )
                .optional(),
              handlingDays: z
                .number()
                .int()
                .describe('Amount of days before first delivery option date')
                .min(0)
                .max(30)
                .optional()
                .nullable(),
              cutOffTime: z
                .object({
                  hours: z
                    .number()
                    .int()
                    .describe('Hours in format 0-23')
                    .min(0)
                    .max(23)
                    .optional()
                    .nullable(),
                  minutes: z
                    .number()
                    .int()
                    .describe('Minutes 0-59')
                    .min(0)
                    .max(59)
                    .optional()
                    .nullable(),
                })
                .describe(
                  'Cut off time after which first delivery option would be for next day'
                )
                .optional(),
              timeWindows: z
                .array(
                  z.object({
                    day: z
                      .enum(['MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT', 'SUN'])
                      .describe('The day of week this availability relates to.')
                      .optional(),
                    start: z
                      .object({
                        hours: z
                          .number()
                          .int()
                          .describe('Hours')
                          .min(0)
                          .max(23)
                          .optional(),
                        minutes: z
                          .number()
                          .int()
                          .describe('Minutes')
                          .min(0)
                          .max(59)
                          .optional(),
                      })
                      .describe('The start time in time of day representation.')
                      .optional(),
                    end: z
                      .object({
                        hours: z
                          .number()
                          .int()
                          .describe('Hours')
                          .min(0)
                          .max(23)
                          .optional(),
                        minutes: z
                          .number()
                          .int()
                          .describe('Minutes')
                          .min(0)
                          .max(59)
                          .optional(),
                      })
                      .describe('The end time in time of day representation.')
                      .optional(),
                    enabled: z
                      .boolean()
                      .describe(
                        'Whether this timeWindow availability is enabled.'
                      )
                      .optional()
                      .nullable(),
                  })
                )
                .min(0)
                .max(100)
                .optional(),
            })
            .optional(),
          rates: z
            .array(
              z.object({
                amount: z
                  .string()
                  .describe(
                    'there is an AND logic between all the conditions. Empty conditions means true.\nThe amount of the rate that will be returned if all conditions are met.'
                  )
                  .optional(),
                conditions: z
                  .array(
                    z.object({
                      type: z
                        .enum([
                          'BY_TOTAL_WEIGHT',
                          'BY_TOTAL_PRICE',
                          'BY_TOTAL_QUANTITY',
                        ])
                        .optional(),
                      value: z
                        .string()
                        .describe(
                          'The value in respective to the condition type\nWeight values should be in the same weight units of the store: KG / LB\nTotal price is according to the store currency\nQuantity of items should be integers'
                        )
                        .optional(),
                      operator: z
                        .enum(['EQ', 'GT', 'GTE', 'LT', 'LTE'])
                        .describe('Logical operator.')
                        .optional(),
                    })
                  )
                  .min(0)
                  .max(10)
                  .optional(),
                multiplyByQuantity: z
                  .boolean()
                  .describe(
                    'When this flag is set to true, multiply the amount by the number of line items passed on the request.'
                  )
                  .optional(),
              })
            )
            .max(50)
            .optional(),
          _createdDate: z
            .date()
            .describe('Date and time the LocalDeliveryOption was created.')
            .optional()
            .nullable(),
          _updatedDate: z
            .date()
            .describe('Date and time the LocalDeliveryOption was last updated.')
            .optional()
            .nullable(),
          deliveryRegionIds: z.array(z.string()).max(50).optional(),
        }),
        z.xor([
          z.object({
            zipConfig: z.never().optional(),
            radiusConfig: z.never().optional(),
            customAreaConfig: z.never().optional(),
            cityConfig: z.never().optional(),
          }),
          z.object({
            radiusConfig: z.never().optional(),
            customAreaConfig: z.never().optional(),
            cityConfig: z.never().optional(),
            zipConfig: z.object({ zipCodes: z.array(z.string()).optional() }),
          }),
          z.object({
            zipConfig: z.never().optional(),
            customAreaConfig: z.never().optional(),
            cityConfig: z.never().optional(),
            radiusConfig: z.object({
              radius: z
                .number()
                .describe("Delivery circle's radius")
                .min(0.1)
                .max(50)
                .optional(),
              lengthUnit: z
                .enum(['UNSPECIFIED_LENGTH_UNIT', 'KM', 'MI'])
                .describe("Radius' unit, taken from site properties")
                .optional(),
            }),
          }),
          z.object({
            zipConfig: z.never().optional(),
            radiusConfig: z.never().optional(),
            cityConfig: z.never().optional(),
            customAreaConfig: z.object({
              geocodes: z
                .array(
                  z.object({
                    latitude: z
                      .number()
                      .describe('Address latitude.')
                      .optional()
                      .nullable(),
                    longitude: z
                      .number()
                      .describe('Address longitude.')
                      .optional()
                      .nullable(),
                  })
                )
                .max(300)
                .optional(),
            }),
          }),
          z.object({
            zipConfig: z.never().optional(),
            radiusConfig: z.never().optional(),
            customAreaConfig: z.never().optional(),
            cityConfig: z.object({
              cityItems: z
                .array(
                  z.object({
                    cityName: z
                      .string()
                      .describe('Name of the city')
                      .min(1)
                      .max(100)
                      .optional(),
                    subdivision: z
                      .string()
                      .describe('Subdivision code of the city')
                      .optional()
                      .nullable(),
                    country: z
                      .string()
                      .describe('Country code of the city')
                      .optional(),
                    cityKey: z
                      .string()
                      .describe('Unique code of the city, calculated by Wix')
                      .max(100)
                      .optional()
                      .nullable(),
                  })
                )
                .min(1)
                .max(50)
                .optional(),
            }),
          }),
        ])
      )
    )
    .optional(),
  errors: z
    .array(
      z.object({ _id: z.string().optional(), error: z.string().optional() })
    )
    .optional(),
});
export const BulkUpdateLocalDeliveryOptionRequest = z.object({
  localDeliveryOptions: z
    .array(
      z.intersection(
        z.object({
          _id: z
            .string()
            .describe(
              'LocalDeliveryOptionId - unique identifier of local delivery option'
            )
            .regex(
              /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
              'Must be a valid GUID'
            )
            .optional()
            .nullable(),
          areaName: z
            .string()
            .describe('Area name of Local Delivery Option')
            .max(100)
            .optional()
            .nullable(),
          rate: z
            .string()
            .describe('Flat price of local delivery')
            .optional()
            .nullable(),
          estimatedDeliveryTime: z
            .string()
            .describe('Estimated delivery time description text')
            .max(40)
            .optional()
            .nullable(),
          minimumFreeDeliveryOrderAmount: z
            .number()
            .describe('Minimum order total to be eligible for free delivery')
            .optional()
            .nullable(),
          destinations: z
            .array(
              z.object({
                code: z.string().describe('Country ISO code').optional(),
                subdivisions: z.array(z.string()).max(200).optional(),
              })
            )
            .min(0)
            .max(100)
            .optional(),
          revision: z
            .string()
            .regex(/^\d+$/, 'Must be a valid UInt64 string')
            .describe(
              'Database revision of LocalDeliveryOption entity. Incremented on each modification'
            )
            .optional()
            .nullable(),
          scheduledDeliveryConfig: z
            .object({
              days: z
                .object({
                  monday: z.object({
                    enabledForDelivery: z
                      .boolean()
                      .describe(
                        'Shows whether this day slot is enabled for delivery'
                      ),
                    timeSlots: z
                      .array(
                        z.object({
                          from: z
                            .object({
                              hours: z
                                .number()
                                .int()
                                .describe('Hours in format 0-23')
                                .min(0)
                                .max(23),
                              minutes: z
                                .number()
                                .int()
                                .describe('Minutes 0-59')
                                .min(0)
                                .max(59),
                            })
                            .describe('Starting time point of time slot'),
                          to: z
                            .object({
                              hours: z
                                .number()
                                .int()
                                .describe('Hours in format 0-23')
                                .min(0)
                                .max(23),
                              minutes: z
                                .number()
                                .int()
                                .describe('Minutes 0-59')
                                .min(0)
                                .max(59),
                            })
                            .describe('End time point of time slot'),
                        })
                      )
                      .min(0)
                      .max(8)
                      .optional(),
                  }),
                  tuesday: z.object({
                    enabledForDelivery: z
                      .boolean()
                      .describe(
                        'Shows whether this day slot is enabled for delivery'
                      ),
                    timeSlots: z
                      .array(
                        z.object({
                          from: z
                            .object({
                              hours: z
                                .number()
                                .int()
                                .describe('Hours in format 0-23')
                                .min(0)
                                .max(23),
                              minutes: z
                                .number()
                                .int()
                                .describe('Minutes 0-59')
                                .min(0)
                                .max(59),
                            })
                            .describe('Starting time point of time slot'),
                          to: z
                            .object({
                              hours: z
                                .number()
                                .int()
                                .describe('Hours in format 0-23')
                                .min(0)
                                .max(23),
                              minutes: z
                                .number()
                                .int()
                                .describe('Minutes 0-59')
                                .min(0)
                                .max(59),
                            })
                            .describe('End time point of time slot'),
                        })
                      )
                      .min(0)
                      .max(8)
                      .optional(),
                  }),
                  wednesday: z.object({
                    enabledForDelivery: z
                      .boolean()
                      .describe(
                        'Shows whether this day slot is enabled for delivery'
                      ),
                    timeSlots: z
                      .array(
                        z.object({
                          from: z
                            .object({
                              hours: z
                                .number()
                                .int()
                                .describe('Hours in format 0-23')
                                .min(0)
                                .max(23),
                              minutes: z
                                .number()
                                .int()
                                .describe('Minutes 0-59')
                                .min(0)
                                .max(59),
                            })
                            .describe('Starting time point of time slot'),
                          to: z
                            .object({
                              hours: z
                                .number()
                                .int()
                                .describe('Hours in format 0-23')
                                .min(0)
                                .max(23),
                              minutes: z
                                .number()
                                .int()
                                .describe('Minutes 0-59')
                                .min(0)
                                .max(59),
                            })
                            .describe('End time point of time slot'),
                        })
                      )
                      .min(0)
                      .max(8)
                      .optional(),
                  }),
                  thursday: z.object({
                    enabledForDelivery: z
                      .boolean()
                      .describe(
                        'Shows whether this day slot is enabled for delivery'
                      ),
                    timeSlots: z
                      .array(
                        z.object({
                          from: z
                            .object({
                              hours: z
                                .number()
                                .int()
                                .describe('Hours in format 0-23')
                                .min(0)
                                .max(23),
                              minutes: z
                                .number()
                                .int()
                                .describe('Minutes 0-59')
                                .min(0)
                                .max(59),
                            })
                            .describe('Starting time point of time slot'),
                          to: z
                            .object({
                              hours: z
                                .number()
                                .int()
                                .describe('Hours in format 0-23')
                                .min(0)
                                .max(23),
                              minutes: z
                                .number()
                                .int()
                                .describe('Minutes 0-59')
                                .min(0)
                                .max(59),
                            })
                            .describe('End time point of time slot'),
                        })
                      )
                      .min(0)
                      .max(8)
                      .optional(),
                  }),
                  friday: z.object({
                    enabledForDelivery: z
                      .boolean()
                      .describe(
                        'Shows whether this day slot is enabled for delivery'
                      ),
                    timeSlots: z
                      .array(
                        z.object({
                          from: z
                            .object({
                              hours: z
                                .number()
                                .int()
                                .describe('Hours in format 0-23')
                                .min(0)
                                .max(23),
                              minutes: z
                                .number()
                                .int()
                                .describe('Minutes 0-59')
                                .min(0)
                                .max(59),
                            })
                            .describe('Starting time point of time slot'),
                          to: z
                            .object({
                              hours: z
                                .number()
                                .int()
                                .describe('Hours in format 0-23')
                                .min(0)
                                .max(23),
                              minutes: z
                                .number()
                                .int()
                                .describe('Minutes 0-59')
                                .min(0)
                                .max(59),
                            })
                            .describe('End time point of time slot'),
                        })
                      )
                      .min(0)
                      .max(8)
                      .optional(),
                  }),
                  saturday: z.object({
                    enabledForDelivery: z
                      .boolean()
                      .describe(
                        'Shows whether this day slot is enabled for delivery'
                      ),
                    timeSlots: z
                      .array(
                        z.object({
                          from: z
                            .object({
                              hours: z
                                .number()
                                .int()
                                .describe('Hours in format 0-23')
                                .min(0)
                                .max(23),
                              minutes: z
                                .number()
                                .int()
                                .describe('Minutes 0-59')
                                .min(0)
                                .max(59),
                            })
                            .describe('Starting time point of time slot'),
                          to: z
                            .object({
                              hours: z
                                .number()
                                .int()
                                .describe('Hours in format 0-23')
                                .min(0)
                                .max(23),
                              minutes: z
                                .number()
                                .int()
                                .describe('Minutes 0-59')
                                .min(0)
                                .max(59),
                            })
                            .describe('End time point of time slot'),
                        })
                      )
                      .min(0)
                      .max(8)
                      .optional(),
                  }),
                  sunday: z.object({
                    enabledForDelivery: z
                      .boolean()
                      .describe(
                        'Shows whether this day slot is enabled for delivery'
                      ),
                    timeSlots: z
                      .array(
                        z.object({
                          from: z
                            .object({
                              hours: z
                                .number()
                                .int()
                                .describe('Hours in format 0-23')
                                .min(0)
                                .max(23),
                              minutes: z
                                .number()
                                .int()
                                .describe('Minutes 0-59')
                                .min(0)
                                .max(59),
                            })
                            .describe('Starting time point of time slot'),
                          to: z
                            .object({
                              hours: z
                                .number()
                                .int()
                                .describe('Hours in format 0-23')
                                .min(0)
                                .max(23),
                              minutes: z
                                .number()
                                .int()
                                .describe('Minutes 0-59')
                                .min(0)
                                .max(59),
                            })
                            .describe('End time point of time slot'),
                        })
                      )
                      .min(0)
                      .max(8)
                      .optional(),
                  }),
                })
                .describe(
                  "Days config which contain days when delivery is enabled with it's time slots"
                )
                .optional(),
              handlingDays: z
                .number()
                .int()
                .describe('Amount of days before first delivery option date')
                .min(0)
                .max(30),
              cutOffTime: z
                .object({
                  hours: z
                    .number()
                    .int()
                    .describe('Hours in format 0-23')
                    .min(0)
                    .max(23),
                  minutes: z
                    .number()
                    .int()
                    .describe('Minutes 0-59')
                    .min(0)
                    .max(59),
                })
                .describe(
                  'Cut off time after which first delivery option would be for next day'
                )
                .optional(),
              timeWindows: z
                .array(
                  z.object({
                    day: z
                      .enum(['MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT', 'SUN'])
                      .optional(),
                    start: z
                      .object({
                        hours: z
                          .number()
                          .int()
                          .describe('Hours')
                          .min(0)
                          .max(23)
                          .optional(),
                        minutes: z
                          .number()
                          .int()
                          .describe('Minutes')
                          .min(0)
                          .max(59)
                          .optional(),
                      })
                      .describe('The start time in time of day representation.')
                      .optional(),
                    end: z
                      .object({
                        hours: z
                          .number()
                          .int()
                          .describe('Hours')
                          .min(0)
                          .max(23)
                          .optional(),
                        minutes: z
                          .number()
                          .int()
                          .describe('Minutes')
                          .min(0)
                          .max(59)
                          .optional(),
                      })
                      .describe('The end time in time of day representation.')
                      .optional(),
                    enabled: z
                      .boolean()
                      .describe(
                        'Whether this timeWindow availability is enabled.'
                      )
                      .optional()
                      .nullable(),
                  })
                )
                .min(0)
                .max(100)
                .optional(),
            })
            .optional(),
          rates: z
            .array(
              z.object({
                amount: z
                  .string()
                  .describe(
                    'there is an AND logic between all the conditions. Empty conditions means true.\nThe amount of the rate that will be returned if all conditions are met.'
                  )
                  .optional(),
                conditions: z
                  .array(
                    z.object({
                      type: z
                        .enum([
                          'BY_TOTAL_WEIGHT',
                          'BY_TOTAL_PRICE',
                          'BY_TOTAL_QUANTITY',
                        ])
                        .optional(),
                      value: z
                        .string()
                        .describe(
                          'The value in respective to the condition type\nWeight values should be in the same weight units of the store: KG / LB\nTotal price is according to the store currency\nQuantity of items should be integers'
                        )
                        .optional(),
                      operator: z
                        .enum(['EQ', 'GT', 'GTE', 'LT', 'LTE'])
                        .optional(),
                    })
                  )
                  .min(0)
                  .max(10)
                  .optional(),
                multiplyByQuantity: z
                  .boolean()
                  .describe(
                    'When this flag is set to true, multiply the amount by the number of line items passed on the request.'
                  )
                  .optional(),
              })
            )
            .max(50)
            .optional(),
          _createdDate: z
            .date()
            .describe('Date and time the LocalDeliveryOption was created.')
            .optional()
            .nullable(),
          _updatedDate: z
            .date()
            .describe('Date and time the LocalDeliveryOption was last updated.')
            .optional()
            .nullable(),
          deliveryRegionIds: z.array(z.string()).max(50).optional(),
        }),
        z.xor([
          z.object({
            zipConfig: z.never().optional(),
            radiusConfig: z.never().optional(),
            customAreaConfig: z.never().optional(),
            cityConfig: z.never().optional(),
          }),
          z.object({
            radiusConfig: z.never().optional(),
            customAreaConfig: z.never().optional(),
            cityConfig: z.never().optional(),
            zipConfig: z.object({ zipCodes: z.array(z.string()).optional() }),
          }),
          z.object({
            zipConfig: z.never().optional(),
            customAreaConfig: z.never().optional(),
            cityConfig: z.never().optional(),
            radiusConfig: z.object({
              radius: z
                .number()
                .describe("Delivery circle's radius")
                .min(0.1)
                .max(50)
                .optional(),
              lengthUnit: z
                .enum(['UNSPECIFIED_LENGTH_UNIT', 'KM', 'MI'])
                .describe("Radius' unit, taken from site properties")
                .optional(),
            }),
          }),
          z.object({
            zipConfig: z.never().optional(),
            radiusConfig: z.never().optional(),
            cityConfig: z.never().optional(),
            customAreaConfig: z.object({
              geocodes: z
                .array(
                  z.object({
                    latitude: z
                      .number()
                      .describe('Address latitude.')
                      .optional()
                      .nullable(),
                    longitude: z
                      .number()
                      .describe('Address longitude.')
                      .optional()
                      .nullable(),
                  })
                )
                .max(300)
                .optional(),
            }),
          }),
          z.object({
            zipConfig: z.never().optional(),
            radiusConfig: z.never().optional(),
            customAreaConfig: z.never().optional(),
            cityConfig: z.object({
              cityItems: z
                .array(
                  z.object({
                    cityName: z
                      .string()
                      .describe('Name of the city')
                      .min(1)
                      .max(100)
                      .optional(),
                    subdivision: z
                      .string()
                      .describe('Subdivision code of the city')
                      .optional()
                      .nullable(),
                    country: z
                      .string()
                      .describe('Country code of the city')
                      .optional(),
                    cityKey: z
                      .string()
                      .describe('Unique code of the city, calculated by Wix')
                      .max(100)
                      .optional()
                      .nullable(),
                  })
                )
                .min(1)
                .max(50)
                .optional(),
            }),
          }),
        ])
      )
    )
    .min(1)
    .max(100),
});
export const BulkUpdateLocalDeliveryOptionResponse = z.object({
  localDeliveryOptions: z
    .array(
      z.intersection(
        z.object({
          _id: z
            .string()
            .describe(
              'LocalDeliveryOptionId - unique identifier of local delivery option'
            )
            .regex(
              /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
              'Must be a valid GUID'
            )
            .optional()
            .nullable(),
          areaName: z
            .string()
            .describe('Area name of Local Delivery Option')
            .max(100)
            .optional()
            .nullable(),
          rate: z
            .string()
            .describe('Flat price of local delivery')
            .optional()
            .nullable(),
          estimatedDeliveryTime: z
            .string()
            .describe('Estimated delivery time description text')
            .max(40)
            .optional()
            .nullable(),
          minimumFreeDeliveryOrderAmount: z
            .number()
            .describe('Minimum order total to be eligible for free delivery')
            .optional()
            .nullable(),
          destinations: z
            .array(
              z.object({
                code: z.string().describe('Country ISO code').optional(),
                subdivisions: z.array(z.string()).max(200).optional(),
              })
            )
            .min(0)
            .max(100)
            .optional(),
          revision: z
            .string()
            .regex(/^\d+$/, 'Must be a valid UInt64 string')
            .describe(
              'Database revision of LocalDeliveryOption entity. Incremented on each modification'
            )
            .optional()
            .nullable(),
          scheduledDeliveryConfig: z
            .object({
              days: z
                .object({
                  monday: z
                    .object({
                      enabledForDelivery: z
                        .boolean()
                        .describe(
                          'Shows whether this day slot is enabled for delivery'
                        )
                        .optional()
                        .nullable(),
                      timeSlots: z
                        .array(
                          z.object({
                            from: z
                              .object({
                                hours: z
                                  .number()
                                  .int()
                                  .describe('Hours in format 0-23')
                                  .min(0)
                                  .max(23)
                                  .optional()
                                  .nullable(),
                                minutes: z
                                  .number()
                                  .int()
                                  .describe('Minutes 0-59')
                                  .min(0)
                                  .max(59)
                                  .optional()
                                  .nullable(),
                              })
                              .describe('Starting time point of time slot')
                              .optional(),
                            to: z
                              .object({
                                hours: z
                                  .number()
                                  .int()
                                  .describe('Hours in format 0-23')
                                  .min(0)
                                  .max(23)
                                  .optional()
                                  .nullable(),
                                minutes: z
                                  .number()
                                  .int()
                                  .describe('Minutes 0-59')
                                  .min(0)
                                  .max(59)
                                  .optional()
                                  .nullable(),
                              })
                              .describe('End time point of time slot')
                              .optional(),
                          })
                        )
                        .min(0)
                        .max(8)
                        .optional(),
                    })
                    .optional(),
                  tuesday: z
                    .object({
                      enabledForDelivery: z
                        .boolean()
                        .describe(
                          'Shows whether this day slot is enabled for delivery'
                        )
                        .optional()
                        .nullable(),
                      timeSlots: z
                        .array(
                          z.object({
                            from: z
                              .object({
                                hours: z
                                  .number()
                                  .int()
                                  .describe('Hours in format 0-23')
                                  .min(0)
                                  .max(23)
                                  .optional()
                                  .nullable(),
                                minutes: z
                                  .number()
                                  .int()
                                  .describe('Minutes 0-59')
                                  .min(0)
                                  .max(59)
                                  .optional()
                                  .nullable(),
                              })
                              .describe('Starting time point of time slot')
                              .optional(),
                            to: z
                              .object({
                                hours: z
                                  .number()
                                  .int()
                                  .describe('Hours in format 0-23')
                                  .min(0)
                                  .max(23)
                                  .optional()
                                  .nullable(),
                                minutes: z
                                  .number()
                                  .int()
                                  .describe('Minutes 0-59')
                                  .min(0)
                                  .max(59)
                                  .optional()
                                  .nullable(),
                              })
                              .describe('End time point of time slot')
                              .optional(),
                          })
                        )
                        .min(0)
                        .max(8)
                        .optional(),
                    })
                    .optional(),
                  wednesday: z
                    .object({
                      enabledForDelivery: z
                        .boolean()
                        .describe(
                          'Shows whether this day slot is enabled for delivery'
                        )
                        .optional()
                        .nullable(),
                      timeSlots: z
                        .array(
                          z.object({
                            from: z
                              .object({
                                hours: z
                                  .number()
                                  .int()
                                  .describe('Hours in format 0-23')
                                  .min(0)
                                  .max(23)
                                  .optional()
                                  .nullable(),
                                minutes: z
                                  .number()
                                  .int()
                                  .describe('Minutes 0-59')
                                  .min(0)
                                  .max(59)
                                  .optional()
                                  .nullable(),
                              })
                              .describe('Starting time point of time slot')
                              .optional(),
                            to: z
                              .object({
                                hours: z
                                  .number()
                                  .int()
                                  .describe('Hours in format 0-23')
                                  .min(0)
                                  .max(23)
                                  .optional()
                                  .nullable(),
                                minutes: z
                                  .number()
                                  .int()
                                  .describe('Minutes 0-59')
                                  .min(0)
                                  .max(59)
                                  .optional()
                                  .nullable(),
                              })
                              .describe('End time point of time slot')
                              .optional(),
                          })
                        )
                        .min(0)
                        .max(8)
                        .optional(),
                    })
                    .optional(),
                  thursday: z
                    .object({
                      enabledForDelivery: z
                        .boolean()
                        .describe(
                          'Shows whether this day slot is enabled for delivery'
                        )
                        .optional()
                        .nullable(),
                      timeSlots: z
                        .array(
                          z.object({
                            from: z
                              .object({
                                hours: z
                                  .number()
                                  .int()
                                  .describe('Hours in format 0-23')
                                  .min(0)
                                  .max(23)
                                  .optional()
                                  .nullable(),
                                minutes: z
                                  .number()
                                  .int()
                                  .describe('Minutes 0-59')
                                  .min(0)
                                  .max(59)
                                  .optional()
                                  .nullable(),
                              })
                              .describe('Starting time point of time slot')
                              .optional(),
                            to: z
                              .object({
                                hours: z
                                  .number()
                                  .int()
                                  .describe('Hours in format 0-23')
                                  .min(0)
                                  .max(23)
                                  .optional()
                                  .nullable(),
                                minutes: z
                                  .number()
                                  .int()
                                  .describe('Minutes 0-59')
                                  .min(0)
                                  .max(59)
                                  .optional()
                                  .nullable(),
                              })
                              .describe('End time point of time slot')
                              .optional(),
                          })
                        )
                        .min(0)
                        .max(8)
                        .optional(),
                    })
                    .optional(),
                  friday: z
                    .object({
                      enabledForDelivery: z
                        .boolean()
                        .describe(
                          'Shows whether this day slot is enabled for delivery'
                        )
                        .optional()
                        .nullable(),
                      timeSlots: z
                        .array(
                          z.object({
                            from: z
                              .object({
                                hours: z
                                  .number()
                                  .int()
                                  .describe('Hours in format 0-23')
                                  .min(0)
                                  .max(23)
                                  .optional()
                                  .nullable(),
                                minutes: z
                                  .number()
                                  .int()
                                  .describe('Minutes 0-59')
                                  .min(0)
                                  .max(59)
                                  .optional()
                                  .nullable(),
                              })
                              .describe('Starting time point of time slot')
                              .optional(),
                            to: z
                              .object({
                                hours: z
                                  .number()
                                  .int()
                                  .describe('Hours in format 0-23')
                                  .min(0)
                                  .max(23)
                                  .optional()
                                  .nullable(),
                                minutes: z
                                  .number()
                                  .int()
                                  .describe('Minutes 0-59')
                                  .min(0)
                                  .max(59)
                                  .optional()
                                  .nullable(),
                              })
                              .describe('End time point of time slot')
                              .optional(),
                          })
                        )
                        .min(0)
                        .max(8)
                        .optional(),
                    })
                    .optional(),
                  saturday: z
                    .object({
                      enabledForDelivery: z
                        .boolean()
                        .describe(
                          'Shows whether this day slot is enabled for delivery'
                        )
                        .optional()
                        .nullable(),
                      timeSlots: z
                        .array(
                          z.object({
                            from: z
                              .object({
                                hours: z
                                  .number()
                                  .int()
                                  .describe('Hours in format 0-23')
                                  .min(0)
                                  .max(23)
                                  .optional()
                                  .nullable(),
                                minutes: z
                                  .number()
                                  .int()
                                  .describe('Minutes 0-59')
                                  .min(0)
                                  .max(59)
                                  .optional()
                                  .nullable(),
                              })
                              .describe('Starting time point of time slot')
                              .optional(),
                            to: z
                              .object({
                                hours: z
                                  .number()
                                  .int()
                                  .describe('Hours in format 0-23')
                                  .min(0)
                                  .max(23)
                                  .optional()
                                  .nullable(),
                                minutes: z
                                  .number()
                                  .int()
                                  .describe('Minutes 0-59')
                                  .min(0)
                                  .max(59)
                                  .optional()
                                  .nullable(),
                              })
                              .describe('End time point of time slot')
                              .optional(),
                          })
                        )
                        .min(0)
                        .max(8)
                        .optional(),
                    })
                    .optional(),
                  sunday: z
                    .object({
                      enabledForDelivery: z
                        .boolean()
                        .describe(
                          'Shows whether this day slot is enabled for delivery'
                        )
                        .optional()
                        .nullable(),
                      timeSlots: z
                        .array(
                          z.object({
                            from: z
                              .object({
                                hours: z
                                  .number()
                                  .int()
                                  .describe('Hours in format 0-23')
                                  .min(0)
                                  .max(23)
                                  .optional()
                                  .nullable(),
                                minutes: z
                                  .number()
                                  .int()
                                  .describe('Minutes 0-59')
                                  .min(0)
                                  .max(59)
                                  .optional()
                                  .nullable(),
                              })
                              .describe('Starting time point of time slot')
                              .optional(),
                            to: z
                              .object({
                                hours: z
                                  .number()
                                  .int()
                                  .describe('Hours in format 0-23')
                                  .min(0)
                                  .max(23)
                                  .optional()
                                  .nullable(),
                                minutes: z
                                  .number()
                                  .int()
                                  .describe('Minutes 0-59')
                                  .min(0)
                                  .max(59)
                                  .optional()
                                  .nullable(),
                              })
                              .describe('End time point of time slot')
                              .optional(),
                          })
                        )
                        .min(0)
                        .max(8)
                        .optional(),
                    })
                    .optional(),
                })
                .describe(
                  "Days config which contain days when delivery is enabled with it's time slots"
                )
                .optional(),
              handlingDays: z
                .number()
                .int()
                .describe('Amount of days before first delivery option date')
                .min(0)
                .max(30)
                .optional()
                .nullable(),
              cutOffTime: z
                .object({
                  hours: z
                    .number()
                    .int()
                    .describe('Hours in format 0-23')
                    .min(0)
                    .max(23)
                    .optional()
                    .nullable(),
                  minutes: z
                    .number()
                    .int()
                    .describe('Minutes 0-59')
                    .min(0)
                    .max(59)
                    .optional()
                    .nullable(),
                })
                .describe(
                  'Cut off time after which first delivery option would be for next day'
                )
                .optional(),
              timeWindows: z
                .array(
                  z.object({
                    day: z
                      .enum(['MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT', 'SUN'])
                      .describe('The day of week this availability relates to.')
                      .optional(),
                    start: z
                      .object({
                        hours: z
                          .number()
                          .int()
                          .describe('Hours')
                          .min(0)
                          .max(23)
                          .optional(),
                        minutes: z
                          .number()
                          .int()
                          .describe('Minutes')
                          .min(0)
                          .max(59)
                          .optional(),
                      })
                      .describe('The start time in time of day representation.')
                      .optional(),
                    end: z
                      .object({
                        hours: z
                          .number()
                          .int()
                          .describe('Hours')
                          .min(0)
                          .max(23)
                          .optional(),
                        minutes: z
                          .number()
                          .int()
                          .describe('Minutes')
                          .min(0)
                          .max(59)
                          .optional(),
                      })
                      .describe('The end time in time of day representation.')
                      .optional(),
                    enabled: z
                      .boolean()
                      .describe(
                        'Whether this timeWindow availability is enabled.'
                      )
                      .optional()
                      .nullable(),
                  })
                )
                .min(0)
                .max(100)
                .optional(),
            })
            .optional(),
          rates: z
            .array(
              z.object({
                amount: z
                  .string()
                  .describe(
                    'there is an AND logic between all the conditions. Empty conditions means true.\nThe amount of the rate that will be returned if all conditions are met.'
                  )
                  .optional(),
                conditions: z
                  .array(
                    z.object({
                      type: z
                        .enum([
                          'BY_TOTAL_WEIGHT',
                          'BY_TOTAL_PRICE',
                          'BY_TOTAL_QUANTITY',
                        ])
                        .optional(),
                      value: z
                        .string()
                        .describe(
                          'The value in respective to the condition type\nWeight values should be in the same weight units of the store: KG / LB\nTotal price is according to the store currency\nQuantity of items should be integers'
                        )
                        .optional(),
                      operator: z
                        .enum(['EQ', 'GT', 'GTE', 'LT', 'LTE'])
                        .describe('Logical operator.')
                        .optional(),
                    })
                  )
                  .min(0)
                  .max(10)
                  .optional(),
                multiplyByQuantity: z
                  .boolean()
                  .describe(
                    'When this flag is set to true, multiply the amount by the number of line items passed on the request.'
                  )
                  .optional(),
              })
            )
            .max(50)
            .optional(),
          _createdDate: z
            .date()
            .describe('Date and time the LocalDeliveryOption was created.')
            .optional()
            .nullable(),
          _updatedDate: z
            .date()
            .describe('Date and time the LocalDeliveryOption was last updated.')
            .optional()
            .nullable(),
          deliveryRegionIds: z.array(z.string()).max(50).optional(),
        }),
        z.xor([
          z.object({
            zipConfig: z.never().optional(),
            radiusConfig: z.never().optional(),
            customAreaConfig: z.never().optional(),
            cityConfig: z.never().optional(),
          }),
          z.object({
            radiusConfig: z.never().optional(),
            customAreaConfig: z.never().optional(),
            cityConfig: z.never().optional(),
            zipConfig: z.object({ zipCodes: z.array(z.string()).optional() }),
          }),
          z.object({
            zipConfig: z.never().optional(),
            customAreaConfig: z.never().optional(),
            cityConfig: z.never().optional(),
            radiusConfig: z.object({
              radius: z
                .number()
                .describe("Delivery circle's radius")
                .min(0.1)
                .max(50)
                .optional(),
              lengthUnit: z
                .enum(['UNSPECIFIED_LENGTH_UNIT', 'KM', 'MI'])
                .describe("Radius' unit, taken from site properties")
                .optional(),
            }),
          }),
          z.object({
            zipConfig: z.never().optional(),
            radiusConfig: z.never().optional(),
            cityConfig: z.never().optional(),
            customAreaConfig: z.object({
              geocodes: z
                .array(
                  z.object({
                    latitude: z
                      .number()
                      .describe('Address latitude.')
                      .optional()
                      .nullable(),
                    longitude: z
                      .number()
                      .describe('Address longitude.')
                      .optional()
                      .nullable(),
                  })
                )
                .max(300)
                .optional(),
            }),
          }),
          z.object({
            zipConfig: z.never().optional(),
            radiusConfig: z.never().optional(),
            customAreaConfig: z.never().optional(),
            cityConfig: z.object({
              cityItems: z
                .array(
                  z.object({
                    cityName: z
                      .string()
                      .describe('Name of the city')
                      .min(1)
                      .max(100)
                      .optional(),
                    subdivision: z
                      .string()
                      .describe('Subdivision code of the city')
                      .optional()
                      .nullable(),
                    country: z
                      .string()
                      .describe('Country code of the city')
                      .optional(),
                    cityKey: z
                      .string()
                      .describe('Unique code of the city, calculated by Wix')
                      .max(100)
                      .optional()
                      .nullable(),
                  })
                )
                .min(1)
                .max(50)
                .optional(),
            }),
          }),
        ])
      )
    )
    .optional(),
  errors: z
    .array(
      z.object({ _id: z.string().optional(), error: z.string().optional() })
    )
    .optional(),
});
export const BulkDeleteLocalDeliveryOptionRequest = z.object({
  ids: z.array(z.string()).min(1).max(100),
});
export const BulkDeleteLocalDeliveryOptionResponse = z.object({});
export const AddDeliveryRegionRequest = z.object({
  deliveryRegionId: z
    .string()
    .regex(
      /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
      'Must be a valid GUID'
    ),
  options: z.object({
    localDeliveryOptionId: z
      .string()
      .regex(
        /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
        'Must be a valid GUID'
      ),
    revision: z
      .string()
      .regex(/^-?\d+$/, 'Must be a valid Int64 string')
      .describe('Revision of the PickupLocation')
      .optional()
      .nullable(),
  }),
});
export const AddDeliveryRegionResponse = z.object({
  localDeliveryOption: z
    .intersection(
      z.object({
        _id: z
          .string()
          .describe(
            'LocalDeliveryOptionId - unique identifier of local delivery option'
          )
          .regex(
            /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
            'Must be a valid GUID'
          )
          .optional()
          .nullable(),
        areaName: z
          .string()
          .describe('Area name of Local Delivery Option')
          .max(100)
          .optional()
          .nullable(),
        rate: z
          .string()
          .describe('Flat price of local delivery')
          .optional()
          .nullable(),
        estimatedDeliveryTime: z
          .string()
          .describe('Estimated delivery time description text')
          .max(40)
          .optional()
          .nullable(),
        minimumFreeDeliveryOrderAmount: z
          .number()
          .describe('Minimum order total to be eligible for free delivery')
          .optional()
          .nullable(),
        destinations: z
          .array(
            z.object({
              code: z.string().describe('Country ISO code').optional(),
              subdivisions: z.array(z.string()).max(200).optional(),
            })
          )
          .min(0)
          .max(100)
          .optional(),
        revision: z
          .string()
          .regex(/^\d+$/, 'Must be a valid UInt64 string')
          .describe(
            'Database revision of LocalDeliveryOption entity. Incremented on each modification'
          )
          .optional()
          .nullable(),
        scheduledDeliveryConfig: z
          .object({
            days: z
              .object({
                monday: z
                  .object({
                    enabledForDelivery: z
                      .boolean()
                      .describe(
                        'Shows whether this day slot is enabled for delivery'
                      )
                      .optional()
                      .nullable(),
                    timeSlots: z
                      .array(
                        z.object({
                          from: z
                            .object({
                              hours: z
                                .number()
                                .int()
                                .describe('Hours in format 0-23')
                                .min(0)
                                .max(23)
                                .optional()
                                .nullable(),
                              minutes: z
                                .number()
                                .int()
                                .describe('Minutes 0-59')
                                .min(0)
                                .max(59)
                                .optional()
                                .nullable(),
                            })
                            .describe('Starting time point of time slot')
                            .optional(),
                          to: z
                            .object({
                              hours: z
                                .number()
                                .int()
                                .describe('Hours in format 0-23')
                                .min(0)
                                .max(23)
                                .optional()
                                .nullable(),
                              minutes: z
                                .number()
                                .int()
                                .describe('Minutes 0-59')
                                .min(0)
                                .max(59)
                                .optional()
                                .nullable(),
                            })
                            .describe('End time point of time slot')
                            .optional(),
                        })
                      )
                      .min(0)
                      .max(8)
                      .optional(),
                  })
                  .optional(),
                tuesday: z
                  .object({
                    enabledForDelivery: z
                      .boolean()
                      .describe(
                        'Shows whether this day slot is enabled for delivery'
                      )
                      .optional()
                      .nullable(),
                    timeSlots: z
                      .array(
                        z.object({
                          from: z
                            .object({
                              hours: z
                                .number()
                                .int()
                                .describe('Hours in format 0-23')
                                .min(0)
                                .max(23)
                                .optional()
                                .nullable(),
                              minutes: z
                                .number()
                                .int()
                                .describe('Minutes 0-59')
                                .min(0)
                                .max(59)
                                .optional()
                                .nullable(),
                            })
                            .describe('Starting time point of time slot')
                            .optional(),
                          to: z
                            .object({
                              hours: z
                                .number()
                                .int()
                                .describe('Hours in format 0-23')
                                .min(0)
                                .max(23)
                                .optional()
                                .nullable(),
                              minutes: z
                                .number()
                                .int()
                                .describe('Minutes 0-59')
                                .min(0)
                                .max(59)
                                .optional()
                                .nullable(),
                            })
                            .describe('End time point of time slot')
                            .optional(),
                        })
                      )
                      .min(0)
                      .max(8)
                      .optional(),
                  })
                  .optional(),
                wednesday: z
                  .object({
                    enabledForDelivery: z
                      .boolean()
                      .describe(
                        'Shows whether this day slot is enabled for delivery'
                      )
                      .optional()
                      .nullable(),
                    timeSlots: z
                      .array(
                        z.object({
                          from: z
                            .object({
                              hours: z
                                .number()
                                .int()
                                .describe('Hours in format 0-23')
                                .min(0)
                                .max(23)
                                .optional()
                                .nullable(),
                              minutes: z
                                .number()
                                .int()
                                .describe('Minutes 0-59')
                                .min(0)
                                .max(59)
                                .optional()
                                .nullable(),
                            })
                            .describe('Starting time point of time slot')
                            .optional(),
                          to: z
                            .object({
                              hours: z
                                .number()
                                .int()
                                .describe('Hours in format 0-23')
                                .min(0)
                                .max(23)
                                .optional()
                                .nullable(),
                              minutes: z
                                .number()
                                .int()
                                .describe('Minutes 0-59')
                                .min(0)
                                .max(59)
                                .optional()
                                .nullable(),
                            })
                            .describe('End time point of time slot')
                            .optional(),
                        })
                      )
                      .min(0)
                      .max(8)
                      .optional(),
                  })
                  .optional(),
                thursday: z
                  .object({
                    enabledForDelivery: z
                      .boolean()
                      .describe(
                        'Shows whether this day slot is enabled for delivery'
                      )
                      .optional()
                      .nullable(),
                    timeSlots: z
                      .array(
                        z.object({
                          from: z
                            .object({
                              hours: z
                                .number()
                                .int()
                                .describe('Hours in format 0-23')
                                .min(0)
                                .max(23)
                                .optional()
                                .nullable(),
                              minutes: z
                                .number()
                                .int()
                                .describe('Minutes 0-59')
                                .min(0)
                                .max(59)
                                .optional()
                                .nullable(),
                            })
                            .describe('Starting time point of time slot')
                            .optional(),
                          to: z
                            .object({
                              hours: z
                                .number()
                                .int()
                                .describe('Hours in format 0-23')
                                .min(0)
                                .max(23)
                                .optional()
                                .nullable(),
                              minutes: z
                                .number()
                                .int()
                                .describe('Minutes 0-59')
                                .min(0)
                                .max(59)
                                .optional()
                                .nullable(),
                            })
                            .describe('End time point of time slot')
                            .optional(),
                        })
                      )
                      .min(0)
                      .max(8)
                      .optional(),
                  })
                  .optional(),
                friday: z
                  .object({
                    enabledForDelivery: z
                      .boolean()
                      .describe(
                        'Shows whether this day slot is enabled for delivery'
                      )
                      .optional()
                      .nullable(),
                    timeSlots: z
                      .array(
                        z.object({
                          from: z
                            .object({
                              hours: z
                                .number()
                                .int()
                                .describe('Hours in format 0-23')
                                .min(0)
                                .max(23)
                                .optional()
                                .nullable(),
                              minutes: z
                                .number()
                                .int()
                                .describe('Minutes 0-59')
                                .min(0)
                                .max(59)
                                .optional()
                                .nullable(),
                            })
                            .describe('Starting time point of time slot')
                            .optional(),
                          to: z
                            .object({
                              hours: z
                                .number()
                                .int()
                                .describe('Hours in format 0-23')
                                .min(0)
                                .max(23)
                                .optional()
                                .nullable(),
                              minutes: z
                                .number()
                                .int()
                                .describe('Minutes 0-59')
                                .min(0)
                                .max(59)
                                .optional()
                                .nullable(),
                            })
                            .describe('End time point of time slot')
                            .optional(),
                        })
                      )
                      .min(0)
                      .max(8)
                      .optional(),
                  })
                  .optional(),
                saturday: z
                  .object({
                    enabledForDelivery: z
                      .boolean()
                      .describe(
                        'Shows whether this day slot is enabled for delivery'
                      )
                      .optional()
                      .nullable(),
                    timeSlots: z
                      .array(
                        z.object({
                          from: z
                            .object({
                              hours: z
                                .number()
                                .int()
                                .describe('Hours in format 0-23')
                                .min(0)
                                .max(23)
                                .optional()
                                .nullable(),
                              minutes: z
                                .number()
                                .int()
                                .describe('Minutes 0-59')
                                .min(0)
                                .max(59)
                                .optional()
                                .nullable(),
                            })
                            .describe('Starting time point of time slot')
                            .optional(),
                          to: z
                            .object({
                              hours: z
                                .number()
                                .int()
                                .describe('Hours in format 0-23')
                                .min(0)
                                .max(23)
                                .optional()
                                .nullable(),
                              minutes: z
                                .number()
                                .int()
                                .describe('Minutes 0-59')
                                .min(0)
                                .max(59)
                                .optional()
                                .nullable(),
                            })
                            .describe('End time point of time slot')
                            .optional(),
                        })
                      )
                      .min(0)
                      .max(8)
                      .optional(),
                  })
                  .optional(),
                sunday: z
                  .object({
                    enabledForDelivery: z
                      .boolean()
                      .describe(
                        'Shows whether this day slot is enabled for delivery'
                      )
                      .optional()
                      .nullable(),
                    timeSlots: z
                      .array(
                        z.object({
                          from: z
                            .object({
                              hours: z
                                .number()
                                .int()
                                .describe('Hours in format 0-23')
                                .min(0)
                                .max(23)
                                .optional()
                                .nullable(),
                              minutes: z
                                .number()
                                .int()
                                .describe('Minutes 0-59')
                                .min(0)
                                .max(59)
                                .optional()
                                .nullable(),
                            })
                            .describe('Starting time point of time slot')
                            .optional(),
                          to: z
                            .object({
                              hours: z
                                .number()
                                .int()
                                .describe('Hours in format 0-23')
                                .min(0)
                                .max(23)
                                .optional()
                                .nullable(),
                              minutes: z
                                .number()
                                .int()
                                .describe('Minutes 0-59')
                                .min(0)
                                .max(59)
                                .optional()
                                .nullable(),
                            })
                            .describe('End time point of time slot')
                            .optional(),
                        })
                      )
                      .min(0)
                      .max(8)
                      .optional(),
                  })
                  .optional(),
              })
              .describe(
                "Days config which contain days when delivery is enabled with it's time slots"
              )
              .optional(),
            handlingDays: z
              .number()
              .int()
              .describe('Amount of days before first delivery option date')
              .min(0)
              .max(30)
              .optional()
              .nullable(),
            cutOffTime: z
              .object({
                hours: z
                  .number()
                  .int()
                  .describe('Hours in format 0-23')
                  .min(0)
                  .max(23)
                  .optional()
                  .nullable(),
                minutes: z
                  .number()
                  .int()
                  .describe('Minutes 0-59')
                  .min(0)
                  .max(59)
                  .optional()
                  .nullable(),
              })
              .describe(
                'Cut off time after which first delivery option would be for next day'
              )
              .optional(),
            timeWindows: z
              .array(
                z.object({
                  day: z
                    .enum(['MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT', 'SUN'])
                    .describe('The day of week this availability relates to.')
                    .optional(),
                  start: z
                    .object({
                      hours: z
                        .number()
                        .int()
                        .describe('Hours')
                        .min(0)
                        .max(23)
                        .optional(),
                      minutes: z
                        .number()
                        .int()
                        .describe('Minutes')
                        .min(0)
                        .max(59)
                        .optional(),
                    })
                    .describe('The start time in time of day representation.')
                    .optional(),
                  end: z
                    .object({
                      hours: z
                        .number()
                        .int()
                        .describe('Hours')
                        .min(0)
                        .max(23)
                        .optional(),
                      minutes: z
                        .number()
                        .int()
                        .describe('Minutes')
                        .min(0)
                        .max(59)
                        .optional(),
                    })
                    .describe('The end time in time of day representation.')
                    .optional(),
                  enabled: z
                    .boolean()
                    .describe(
                      'Whether this timeWindow availability is enabled.'
                    )
                    .optional()
                    .nullable(),
                })
              )
              .min(0)
              .max(100)
              .optional(),
          })
          .optional(),
        rates: z
          .array(
            z.object({
              amount: z
                .string()
                .describe(
                  'there is an AND logic between all the conditions. Empty conditions means true.\nThe amount of the rate that will be returned if all conditions are met.'
                )
                .optional(),
              conditions: z
                .array(
                  z.object({
                    type: z
                      .enum([
                        'BY_TOTAL_WEIGHT',
                        'BY_TOTAL_PRICE',
                        'BY_TOTAL_QUANTITY',
                      ])
                      .optional(),
                    value: z
                      .string()
                      .describe(
                        'The value in respective to the condition type\nWeight values should be in the same weight units of the store: KG / LB\nTotal price is according to the store currency\nQuantity of items should be integers'
                      )
                      .optional(),
                    operator: z
                      .enum(['EQ', 'GT', 'GTE', 'LT', 'LTE'])
                      .describe('Logical operator.')
                      .optional(),
                  })
                )
                .min(0)
                .max(10)
                .optional(),
              multiplyByQuantity: z
                .boolean()
                .describe(
                  'When this flag is set to true, multiply the amount by the number of line items passed on the request.'
                )
                .optional(),
            })
          )
          .max(50)
          .optional(),
        _createdDate: z
          .date()
          .describe('Date and time the LocalDeliveryOption was created.')
          .optional()
          .nullable(),
        _updatedDate: z
          .date()
          .describe('Date and time the LocalDeliveryOption was last updated.')
          .optional()
          .nullable(),
        deliveryRegionIds: z.array(z.string()).max(50).optional(),
      }),
      z.xor([
        z.object({
          zipConfig: z.never().optional(),
          radiusConfig: z.never().optional(),
          customAreaConfig: z.never().optional(),
          cityConfig: z.never().optional(),
        }),
        z.object({
          radiusConfig: z.never().optional(),
          customAreaConfig: z.never().optional(),
          cityConfig: z.never().optional(),
          zipConfig: z.object({ zipCodes: z.array(z.string()).optional() }),
        }),
        z.object({
          zipConfig: z.never().optional(),
          customAreaConfig: z.never().optional(),
          cityConfig: z.never().optional(),
          radiusConfig: z.object({
            radius: z
              .number()
              .describe("Delivery circle's radius")
              .min(0.1)
              .max(50)
              .optional(),
            lengthUnit: z
              .enum(['UNSPECIFIED_LENGTH_UNIT', 'KM', 'MI'])
              .describe("Radius' unit, taken from site properties")
              .optional(),
          }),
        }),
        z.object({
          zipConfig: z.never().optional(),
          radiusConfig: z.never().optional(),
          cityConfig: z.never().optional(),
          customAreaConfig: z.object({
            geocodes: z
              .array(
                z.object({
                  latitude: z
                    .number()
                    .describe('Address latitude.')
                    .optional()
                    .nullable(),
                  longitude: z
                    .number()
                    .describe('Address longitude.')
                    .optional()
                    .nullable(),
                })
              )
              .max(300)
              .optional(),
          }),
        }),
        z.object({
          zipConfig: z.never().optional(),
          radiusConfig: z.never().optional(),
          customAreaConfig: z.never().optional(),
          cityConfig: z.object({
            cityItems: z
              .array(
                z.object({
                  cityName: z
                    .string()
                    .describe('Name of the city')
                    .min(1)
                    .max(100)
                    .optional(),
                  subdivision: z
                    .string()
                    .describe('Subdivision code of the city')
                    .optional()
                    .nullable(),
                  country: z
                    .string()
                    .describe('Country code of the city')
                    .optional(),
                  cityKey: z
                    .string()
                    .describe('Unique code of the city, calculated by Wix')
                    .max(100)
                    .optional()
                    .nullable(),
                })
              )
              .min(1)
              .max(50)
              .optional(),
          }),
        }),
      ])
    )
    .optional(),
});
export const RemoveDeliveryRegionRequest = z.object({
  deliveryRegionId: z
    .string()
    .regex(
      /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
      'Must be a valid GUID'
    ),
  options: z.object({
    localDeliveryOptionId: z
      .string()
      .regex(
        /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
        'Must be a valid GUID'
      ),
    revision: z
      .string()
      .regex(/^-?\d+$/, 'Must be a valid Int64 string')
      .describe('Revision of the PickupLocation')
      .optional()
      .nullable(),
  }),
});
export const RemoveDeliveryRegionResponse = z.object({
  localDeliveryOption: z
    .intersection(
      z.object({
        _id: z
          .string()
          .describe(
            'LocalDeliveryOptionId - unique identifier of local delivery option'
          )
          .regex(
            /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
            'Must be a valid GUID'
          )
          .optional()
          .nullable(),
        areaName: z
          .string()
          .describe('Area name of Local Delivery Option')
          .max(100)
          .optional()
          .nullable(),
        rate: z
          .string()
          .describe('Flat price of local delivery')
          .optional()
          .nullable(),
        estimatedDeliveryTime: z
          .string()
          .describe('Estimated delivery time description text')
          .max(40)
          .optional()
          .nullable(),
        minimumFreeDeliveryOrderAmount: z
          .number()
          .describe('Minimum order total to be eligible for free delivery')
          .optional()
          .nullable(),
        destinations: z
          .array(
            z.object({
              code: z.string().describe('Country ISO code').optional(),
              subdivisions: z.array(z.string()).max(200).optional(),
            })
          )
          .min(0)
          .max(100)
          .optional(),
        revision: z
          .string()
          .regex(/^\d+$/, 'Must be a valid UInt64 string')
          .describe(
            'Database revision of LocalDeliveryOption entity. Incremented on each modification'
          )
          .optional()
          .nullable(),
        scheduledDeliveryConfig: z
          .object({
            days: z
              .object({
                monday: z
                  .object({
                    enabledForDelivery: z
                      .boolean()
                      .describe(
                        'Shows whether this day slot is enabled for delivery'
                      )
                      .optional()
                      .nullable(),
                    timeSlots: z
                      .array(
                        z.object({
                          from: z
                            .object({
                              hours: z
                                .number()
                                .int()
                                .describe('Hours in format 0-23')
                                .min(0)
                                .max(23)
                                .optional()
                                .nullable(),
                              minutes: z
                                .number()
                                .int()
                                .describe('Minutes 0-59')
                                .min(0)
                                .max(59)
                                .optional()
                                .nullable(),
                            })
                            .describe('Starting time point of time slot')
                            .optional(),
                          to: z
                            .object({
                              hours: z
                                .number()
                                .int()
                                .describe('Hours in format 0-23')
                                .min(0)
                                .max(23)
                                .optional()
                                .nullable(),
                              minutes: z
                                .number()
                                .int()
                                .describe('Minutes 0-59')
                                .min(0)
                                .max(59)
                                .optional()
                                .nullable(),
                            })
                            .describe('End time point of time slot')
                            .optional(),
                        })
                      )
                      .min(0)
                      .max(8)
                      .optional(),
                  })
                  .optional(),
                tuesday: z
                  .object({
                    enabledForDelivery: z
                      .boolean()
                      .describe(
                        'Shows whether this day slot is enabled for delivery'
                      )
                      .optional()
                      .nullable(),
                    timeSlots: z
                      .array(
                        z.object({
                          from: z
                            .object({
                              hours: z
                                .number()
                                .int()
                                .describe('Hours in format 0-23')
                                .min(0)
                                .max(23)
                                .optional()
                                .nullable(),
                              minutes: z
                                .number()
                                .int()
                                .describe('Minutes 0-59')
                                .min(0)
                                .max(59)
                                .optional()
                                .nullable(),
                            })
                            .describe('Starting time point of time slot')
                            .optional(),
                          to: z
                            .object({
                              hours: z
                                .number()
                                .int()
                                .describe('Hours in format 0-23')
                                .min(0)
                                .max(23)
                                .optional()
                                .nullable(),
                              minutes: z
                                .number()
                                .int()
                                .describe('Minutes 0-59')
                                .min(0)
                                .max(59)
                                .optional()
                                .nullable(),
                            })
                            .describe('End time point of time slot')
                            .optional(),
                        })
                      )
                      .min(0)
                      .max(8)
                      .optional(),
                  })
                  .optional(),
                wednesday: z
                  .object({
                    enabledForDelivery: z
                      .boolean()
                      .describe(
                        'Shows whether this day slot is enabled for delivery'
                      )
                      .optional()
                      .nullable(),
                    timeSlots: z
                      .array(
                        z.object({
                          from: z
                            .object({
                              hours: z
                                .number()
                                .int()
                                .describe('Hours in format 0-23')
                                .min(0)
                                .max(23)
                                .optional()
                                .nullable(),
                              minutes: z
                                .number()
                                .int()
                                .describe('Minutes 0-59')
                                .min(0)
                                .max(59)
                                .optional()
                                .nullable(),
                            })
                            .describe('Starting time point of time slot')
                            .optional(),
                          to: z
                            .object({
                              hours: z
                                .number()
                                .int()
                                .describe('Hours in format 0-23')
                                .min(0)
                                .max(23)
                                .optional()
                                .nullable(),
                              minutes: z
                                .number()
                                .int()
                                .describe('Minutes 0-59')
                                .min(0)
                                .max(59)
                                .optional()
                                .nullable(),
                            })
                            .describe('End time point of time slot')
                            .optional(),
                        })
                      )
                      .min(0)
                      .max(8)
                      .optional(),
                  })
                  .optional(),
                thursday: z
                  .object({
                    enabledForDelivery: z
                      .boolean()
                      .describe(
                        'Shows whether this day slot is enabled for delivery'
                      )
                      .optional()
                      .nullable(),
                    timeSlots: z
                      .array(
                        z.object({
                          from: z
                            .object({
                              hours: z
                                .number()
                                .int()
                                .describe('Hours in format 0-23')
                                .min(0)
                                .max(23)
                                .optional()
                                .nullable(),
                              minutes: z
                                .number()
                                .int()
                                .describe('Minutes 0-59')
                                .min(0)
                                .max(59)
                                .optional()
                                .nullable(),
                            })
                            .describe('Starting time point of time slot')
                            .optional(),
                          to: z
                            .object({
                              hours: z
                                .number()
                                .int()
                                .describe('Hours in format 0-23')
                                .min(0)
                                .max(23)
                                .optional()
                                .nullable(),
                              minutes: z
                                .number()
                                .int()
                                .describe('Minutes 0-59')
                                .min(0)
                                .max(59)
                                .optional()
                                .nullable(),
                            })
                            .describe('End time point of time slot')
                            .optional(),
                        })
                      )
                      .min(0)
                      .max(8)
                      .optional(),
                  })
                  .optional(),
                friday: z
                  .object({
                    enabledForDelivery: z
                      .boolean()
                      .describe(
                        'Shows whether this day slot is enabled for delivery'
                      )
                      .optional()
                      .nullable(),
                    timeSlots: z
                      .array(
                        z.object({
                          from: z
                            .object({
                              hours: z
                                .number()
                                .int()
                                .describe('Hours in format 0-23')
                                .min(0)
                                .max(23)
                                .optional()
                                .nullable(),
                              minutes: z
                                .number()
                                .int()
                                .describe('Minutes 0-59')
                                .min(0)
                                .max(59)
                                .optional()
                                .nullable(),
                            })
                            .describe('Starting time point of time slot')
                            .optional(),
                          to: z
                            .object({
                              hours: z
                                .number()
                                .int()
                                .describe('Hours in format 0-23')
                                .min(0)
                                .max(23)
                                .optional()
                                .nullable(),
                              minutes: z
                                .number()
                                .int()
                                .describe('Minutes 0-59')
                                .min(0)
                                .max(59)
                                .optional()
                                .nullable(),
                            })
                            .describe('End time point of time slot')
                            .optional(),
                        })
                      )
                      .min(0)
                      .max(8)
                      .optional(),
                  })
                  .optional(),
                saturday: z
                  .object({
                    enabledForDelivery: z
                      .boolean()
                      .describe(
                        'Shows whether this day slot is enabled for delivery'
                      )
                      .optional()
                      .nullable(),
                    timeSlots: z
                      .array(
                        z.object({
                          from: z
                            .object({
                              hours: z
                                .number()
                                .int()
                                .describe('Hours in format 0-23')
                                .min(0)
                                .max(23)
                                .optional()
                                .nullable(),
                              minutes: z
                                .number()
                                .int()
                                .describe('Minutes 0-59')
                                .min(0)
                                .max(59)
                                .optional()
                                .nullable(),
                            })
                            .describe('Starting time point of time slot')
                            .optional(),
                          to: z
                            .object({
                              hours: z
                                .number()
                                .int()
                                .describe('Hours in format 0-23')
                                .min(0)
                                .max(23)
                                .optional()
                                .nullable(),
                              minutes: z
                                .number()
                                .int()
                                .describe('Minutes 0-59')
                                .min(0)
                                .max(59)
                                .optional()
                                .nullable(),
                            })
                            .describe('End time point of time slot')
                            .optional(),
                        })
                      )
                      .min(0)
                      .max(8)
                      .optional(),
                  })
                  .optional(),
                sunday: z
                  .object({
                    enabledForDelivery: z
                      .boolean()
                      .describe(
                        'Shows whether this day slot is enabled for delivery'
                      )
                      .optional()
                      .nullable(),
                    timeSlots: z
                      .array(
                        z.object({
                          from: z
                            .object({
                              hours: z
                                .number()
                                .int()
                                .describe('Hours in format 0-23')
                                .min(0)
                                .max(23)
                                .optional()
                                .nullable(),
                              minutes: z
                                .number()
                                .int()
                                .describe('Minutes 0-59')
                                .min(0)
                                .max(59)
                                .optional()
                                .nullable(),
                            })
                            .describe('Starting time point of time slot')
                            .optional(),
                          to: z
                            .object({
                              hours: z
                                .number()
                                .int()
                                .describe('Hours in format 0-23')
                                .min(0)
                                .max(23)
                                .optional()
                                .nullable(),
                              minutes: z
                                .number()
                                .int()
                                .describe('Minutes 0-59')
                                .min(0)
                                .max(59)
                                .optional()
                                .nullable(),
                            })
                            .describe('End time point of time slot')
                            .optional(),
                        })
                      )
                      .min(0)
                      .max(8)
                      .optional(),
                  })
                  .optional(),
              })
              .describe(
                "Days config which contain days when delivery is enabled with it's time slots"
              )
              .optional(),
            handlingDays: z
              .number()
              .int()
              .describe('Amount of days before first delivery option date')
              .min(0)
              .max(30)
              .optional()
              .nullable(),
            cutOffTime: z
              .object({
                hours: z
                  .number()
                  .int()
                  .describe('Hours in format 0-23')
                  .min(0)
                  .max(23)
                  .optional()
                  .nullable(),
                minutes: z
                  .number()
                  .int()
                  .describe('Minutes 0-59')
                  .min(0)
                  .max(59)
                  .optional()
                  .nullable(),
              })
              .describe(
                'Cut off time after which first delivery option would be for next day'
              )
              .optional(),
            timeWindows: z
              .array(
                z.object({
                  day: z
                    .enum(['MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT', 'SUN'])
                    .describe('The day of week this availability relates to.')
                    .optional(),
                  start: z
                    .object({
                      hours: z
                        .number()
                        .int()
                        .describe('Hours')
                        .min(0)
                        .max(23)
                        .optional(),
                      minutes: z
                        .number()
                        .int()
                        .describe('Minutes')
                        .min(0)
                        .max(59)
                        .optional(),
                    })
                    .describe('The start time in time of day representation.')
                    .optional(),
                  end: z
                    .object({
                      hours: z
                        .number()
                        .int()
                        .describe('Hours')
                        .min(0)
                        .max(23)
                        .optional(),
                      minutes: z
                        .number()
                        .int()
                        .describe('Minutes')
                        .min(0)
                        .max(59)
                        .optional(),
                    })
                    .describe('The end time in time of day representation.')
                    .optional(),
                  enabled: z
                    .boolean()
                    .describe(
                      'Whether this timeWindow availability is enabled.'
                    )
                    .optional()
                    .nullable(),
                })
              )
              .min(0)
              .max(100)
              .optional(),
          })
          .optional(),
        rates: z
          .array(
            z.object({
              amount: z
                .string()
                .describe(
                  'there is an AND logic between all the conditions. Empty conditions means true.\nThe amount of the rate that will be returned if all conditions are met.'
                )
                .optional(),
              conditions: z
                .array(
                  z.object({
                    type: z
                      .enum([
                        'BY_TOTAL_WEIGHT',
                        'BY_TOTAL_PRICE',
                        'BY_TOTAL_QUANTITY',
                      ])
                      .optional(),
                    value: z
                      .string()
                      .describe(
                        'The value in respective to the condition type\nWeight values should be in the same weight units of the store: KG / LB\nTotal price is according to the store currency\nQuantity of items should be integers'
                      )
                      .optional(),
                    operator: z
                      .enum(['EQ', 'GT', 'GTE', 'LT', 'LTE'])
                      .describe('Logical operator.')
                      .optional(),
                  })
                )
                .min(0)
                .max(10)
                .optional(),
              multiplyByQuantity: z
                .boolean()
                .describe(
                  'When this flag is set to true, multiply the amount by the number of line items passed on the request.'
                )
                .optional(),
            })
          )
          .max(50)
          .optional(),
        _createdDate: z
          .date()
          .describe('Date and time the LocalDeliveryOption was created.')
          .optional()
          .nullable(),
        _updatedDate: z
          .date()
          .describe('Date and time the LocalDeliveryOption was last updated.')
          .optional()
          .nullable(),
        deliveryRegionIds: z.array(z.string()).max(50).optional(),
      }),
      z.xor([
        z.object({
          zipConfig: z.never().optional(),
          radiusConfig: z.never().optional(),
          customAreaConfig: z.never().optional(),
          cityConfig: z.never().optional(),
        }),
        z.object({
          radiusConfig: z.never().optional(),
          customAreaConfig: z.never().optional(),
          cityConfig: z.never().optional(),
          zipConfig: z.object({ zipCodes: z.array(z.string()).optional() }),
        }),
        z.object({
          zipConfig: z.never().optional(),
          customAreaConfig: z.never().optional(),
          cityConfig: z.never().optional(),
          radiusConfig: z.object({
            radius: z
              .number()
              .describe("Delivery circle's radius")
              .min(0.1)
              .max(50)
              .optional(),
            lengthUnit: z
              .enum(['UNSPECIFIED_LENGTH_UNIT', 'KM', 'MI'])
              .describe("Radius' unit, taken from site properties")
              .optional(),
          }),
        }),
        z.object({
          zipConfig: z.never().optional(),
          radiusConfig: z.never().optional(),
          cityConfig: z.never().optional(),
          customAreaConfig: z.object({
            geocodes: z
              .array(
                z.object({
                  latitude: z
                    .number()
                    .describe('Address latitude.')
                    .optional()
                    .nullable(),
                  longitude: z
                    .number()
                    .describe('Address longitude.')
                    .optional()
                    .nullable(),
                })
              )
              .max(300)
              .optional(),
          }),
        }),
        z.object({
          zipConfig: z.never().optional(),
          radiusConfig: z.never().optional(),
          customAreaConfig: z.never().optional(),
          cityConfig: z.object({
            cityItems: z
              .array(
                z.object({
                  cityName: z
                    .string()
                    .describe('Name of the city')
                    .min(1)
                    .max(100)
                    .optional(),
                  subdivision: z
                    .string()
                    .describe('Subdivision code of the city')
                    .optional()
                    .nullable(),
                  country: z
                    .string()
                    .describe('Country code of the city')
                    .optional(),
                  cityKey: z
                    .string()
                    .describe('Unique code of the city, calculated by Wix')
                    .max(100)
                    .optional()
                    .nullable(),
                })
              )
              .min(1)
              .max(50)
              .optional(),
          }),
        }),
      ])
    )
    .optional(),
});
